import { __awaiter, __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, Injectable, ɵɵinject, EventEmitter, ViewChild, ElementRef, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import esriLoader, { loadCss } from 'esri-loader';
import { BehaviorSubject } from 'rxjs';

// Map Library Configuration Settings
import * as ɵngcc0 from '@angular/core';

const _c0 = ["map"];
const JS_API_VERSION = 4.14;
const DOJO_CONFIG = {
    async: true,
    packages: [{ name: "fcl", location: `${window.location.pathname}assets/fcl` }]
};
// Enumerations
var EButtonPosition;
(function (EButtonPosition) {
    EButtonPosition["topLeft"] = "top-left";
    EButtonPosition["topRight"] = "top-right";
    EButtonPosition["bottomLeft"] = "bottom-left";
    EButtonPosition["bottomRight"] = "bottom-right";
})(EButtonPosition || (EButtonPosition = {}));
var ELayerType;
(function (ELayerType) {
    ELayerType[ELayerType["FeatureLayer"] = 0] = "FeatureLayer";
    ELayerType[ELayerType["MapImageLayer"] = 1] = "MapImageLayer";
    ELayerType[ELayerType["GraphicsLayer"] = 2] = "GraphicsLayer";
})(ELayerType || (ELayerType = {}));
var EMapType;
(function (EMapType) {
    EMapType[EMapType["Map"] = 0] = "Map";
    EMapType[EMapType["WebMap"] = 1] = "WebMap";
})(EMapType || (EMapType = {}));
var EThirdPartyMapButton;
(function (EThirdPartyMapButton) {
    EThirdPartyMapButton[EThirdPartyMapButton["Google"] = 0] = "Google";
    EThirdPartyMapButton[EThirdPartyMapButton["Bing"] = 1] = "Bing";
})(EThirdPartyMapButton || (EThirdPartyMapButton = {}));
var EActiveClickType;
(function (EActiveClickType) {
    EActiveClickType[EActiveClickType["esri"] = 0] = "esri";
    EActiveClickType[EActiveClickType["bingMaps"] = 1] = "bingMaps";
    EActiveClickType[EActiveClickType["coords"] = 2] = "coords";
    EActiveClickType[EActiveClickType["draw"] = 3] = "draw";
    EActiveClickType[EActiveClickType["elevationProfile"] = 4] = "elevationProfile";
    EActiveClickType[EActiveClickType["googleMaps"] = 5] = "googleMaps";
    EActiveClickType[EActiveClickType["featureClickSelect"] = 6] = "featureClickSelect";
    EActiveClickType[EActiveClickType["featureDrawSelect"] = 7] = "featureDrawSelect";
    EActiveClickType[EActiveClickType["measure"] = 8] = "measure";
    EActiveClickType[EActiveClickType["parcelDetails"] = 9] = "parcelDetails";
    EActiveClickType[EActiveClickType["snapping"] = 10] = "snapping";
})(EActiveClickType || (EActiveClickType = {}));
// Classes
class MapConfig2 {
    constructor(mapType, mapProperties, webMapProperties, mapViewProperties, mapInstance) {
        this.mapType = mapType;
        this.mapProperties = mapProperties;
        this.webMapProperties = webMapProperties;
        this.mapViewProperties = mapViewProperties;
        this.mapInstance = mapInstance;
    }
}
class MapConfig2Maker {
    static create(e) {
        return {
            mapType: (e && e.mapType) ? e.mapType : EMapType.Map,
            mapProperties: (e && e.mapProperties) ? e.mapProperties : { basemap: 'topo' },
            webMapProperties: (e && e.webMapProperties) ? e.webMapProperties : { portalItem: { id: 'e691172598f04ea8881cd2a4adaa45ba' } },
            mapViewProperties: (e && e.mapViewProperties) ? e.mapViewProperties : { center: [-74, 42.5], zoom: 7 },
            mapInstance: (e && e.mapInstance) ? e.mapInstance : MapInstanceMaker.create()
        };
    }
}
class MapInstance {
    constructor(options) {
        this.internalState = {};
        this.options = options;
        // Default Internal State for a Map Instance
        this.internalState.expandableWidgets = [];
        this.internalState.actionButtonWidgets = [];
        this.internalState.ActiveClickType = EActiveClickType.esri;
        this.internalState.coords$ = new BehaviorSubject(null);
        this.internalState.customHoverInfo = { hoverInfoElement: null, hoverInfoProperties: [] };
        this.internalState.graphicOnHover = new BehaviorSubject(null);
        this.internalState.sketchViewModels = [];
        this.internalState.popupActions = [];
    }
}
class MapInstanceMaker {
    static create(e) {
        return new MapInstance({
            lyrsDefFeatureLyr: (e && e.lyrsDefFeatureLyr) ? e.lyrsDefFeatureLyr : [],
            lyrsDefMapImageLyr: (e && e.lyrsDefMapImageLyr) ? e.lyrsDefMapImageLyr : [],
            lyrsDefGraphicsLyr: (e && e.lyrsDefGraphicsLyr) ? e.lyrsDefGraphicsLyr : [],
            lyrsDefClusterLyr: (e && e.lyrsDefClusterLyr) ? e.lyrsDefClusterLyr : [],
            mapEventHoverInfos: (e && e.mapEventHoverInfos) ? e.mapEventHoverInfos : null,
            mapEventGetGraphicOnHover: (e && e.mapEventGetGraphicOnHover) ? e.mapEventGetGraphicOnHover : false,
            mapEventSnapping: (e && e.mapEventSnapping) ? e.mapEventSnapping : null,
            popupActions: (e && e.popupActions) ? e.popupActions : null,
            // sketchViewModels: (e && e.sketchViewModels) ? e.sketchViewModels: null,
            widgetAreaMeasurement: (e && e.widgetAreaMeasurement) ? e.widgetAreaMeasurement : null,
            widgetBasemapGallery: (e && e.widgetBasemapGallery) ? e.widgetBasemapGallery : null,
            widgetBasemapToggle: (e && e.widgetBasemapToggle) ? e.widgetBasemapToggle : null,
            widgetBingMaps: (e && e.widgetBingMaps) ? e.widgetBingMaps : null,
            widgetBookmarks: (e && e.widgetBookmarks) ? e.widgetBookmarks : null,
            widgetCommand: (e && e.widgetCommand) ? e.widgetCommand : null,
            widgetCoordinateConversion: (e && e.widgetCoordinateConversion) ? e.widgetCoordinateConversion : null,
            widgetCoordinateOnClick: (e && e.widgetCoordinateOnClick) ? e.widgetCoordinateOnClick : null,
            widgetDistanceMeasurement: (e && e.widgetDistanceMeasurement) ? e.widgetDistanceMeasurement : null,
            widgetElevationProfile: (e && e.widgetElevationProfile) ? e.widgetElevationProfile : null,
            widgetFullscreen: (e && e.widgetFullscreen) ? e.widgetFullscreen : null,
            widgetGoogleMaps: (e && e.widgetGoogleMaps) ? e.widgetGoogleMaps : null,
            widgetHome: (e && e.widgetHome) ? e.widgetHome : null,
            widgetLayerList: (e && e.widgetLayerList) ? e.widgetLayerList : null,
            widgetLegend: (e && e.widgetLegend) ? e.widgetLegend : null,
            widgetPrint: (e && e.widgetPrint) ? e.widgetPrint : null,
            widgetScaleBar: (e && e.widgetScaleBar) ? e.widgetScaleBar : null,
            widgetSearch: (e && e.widgetSearch) ? e.widgetSearch : null
        });
    }
}
//// Utility Classes ////
class QueryProperties {
    constructor(layerType, layerId) {
        this.sublayerId = null;
        this.geometry = null;
        this.outFields = ['*'];
        this.outSpatialReferenceWKID = 102100;
        this.returnDistinctValues = false;
        this.returnExceededLimitFeatures = true;
        this.returnGeometry = true;
        this.spatialRelationship = 'intersects';
        this.text = null;
        this.where = null;
        this.layerType = layerType;
        this.layerId = layerId;
    }
}
class IPopupActionProperties {
    constructor() {
        /** Numeric Id of the sublayer (Only for MapImageLayers) */
        this.sublayerId = null;
    }
}

let ClusterLayerService = class ClusterLayerService {
    constructor() {
    }
    /**
     * Makes ClusterLayers from Definition in the MapConfig
     * @param map - Esri Map
     * @param clusterLayerDefs - IClusterLayerProperties[]
     */
    loadClusterLayers(map, clusterLayerDefs) {
        return __awaiter(this, void 0, void 0, function* () {
            this.map = map;
            yield this._loadEsriDependencies();
            this._initializeMap(map, clusterLayerDefs);
        });
    }
    /**
     * Makes ClusterLayer from Graphics
     * @param map - Esri Map
     * @param clusterFromGraphics - IClusterLayerFromGraphics
     */
    makeClusterLayerFromGraphics(map, clusterFromGraphics) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._loadEsriDependencies();
            this.map = map;
            // let CLProps: ClusterLayerProperties = Object.assign({ layerToClusterType: LayerType.GraphicsLayer, layerToClusterId: "" }, clusterFromGraphics);
            const GRAPHICS_DATA = this.graphicsCollectionToFormattedFeatures(clusterFromGraphics.graphics);
            this.initFlareClusterLayer(GRAPHICS_DATA, this.map, clusterFromGraphics);
        });
    }
    ;
    _loadEsriDependencies() {
        return __awaiter(this, void 0, void 0, function* () {
            const [EsriClassBreaksRenderer, EsriGraphic, EsriGraphicsLayer, EsriFeatureLayer, EsriPopupTemplate, EsriSimpleLineSymbol, EsriSimpleMarkerSymbol, EsriSpatialReference, webMerUtils, fcl] = yield esriLoader.loadModules([
                'esri/renderers/ClassBreaksRenderer',
                'esri/Graphic',
                'esri/layers/GraphicsLayer',
                'esri/layers/FeatureLayer',
                'esri/PopupTemplate',
                'esri/symbols/SimpleLineSymbol',
                'esri/symbols/SimpleMarkerSymbol',
                'esri/geometry/SpatialReference',
                'esri/geometry/support/webMercatorUtils',
                'fcl/FlareClusterLayer_v4'
            ]);
            this.EsriSimpleMarkerSymbol = EsriSimpleMarkerSymbol;
            this.EsriClassBreaksRenderer = EsriClassBreaksRenderer;
            this.EsriSimpleLineSymbol = EsriSimpleLineSymbol;
            this.EsriPopupTemplate = EsriPopupTemplate;
            this.EsriSpatialReference = EsriSpatialReference;
            this.fcl = fcl;
            this.webMerUtils = webMerUtils;
            this.EsriGraphic = EsriGraphic;
            this.EsriGraphicsLayer = EsriGraphicsLayer;
            this.EsriFeatureLayer = EsriFeatureLayer;
        });
    }
    _initializeMap(map, clusterLayerDefs) {
        // make cluster layers
        clusterLayerDefs.forEach((clusterProperty) => {
            this.makeClusterLayersFromDefs(clusterProperty, map);
        });
    }
    getFeatures(map, featureLayer, clusterProps) {
        return __awaiter(this, void 0, void 0, function* () {
            const oidQUERY = featureLayer.createQuery();
            oidQUERY.where = '1=1';
            const oidList = yield featureLayer.queryObjectIds(oidQUERY);
            const QUERY = featureLayer.createQuery();
            const NUM = featureLayer.maxRecordCount ? featureLayer.maxRecordCount : 1000;
            let featureCollection = [];
            let results;
            let start = 0;
            while (start < oidList.length) {
                QUERY.outFields = ["*"]; //clusterProps.popup.fields;
                QUERY.objectIds = start + NUM > oidList.length ? oidList.slice(start, oidList.length) : oidList.slice(start, start + NUM);
                results = yield featureLayer.queryFeatures(QUERY);
                featureCollection = featureCollection.concat(results.features);
                start += NUM;
            }
            // console.log("NUM OF FEATS: ", featureCollection.length)
            return featureCollection;
        });
    }
    ;
    //private initFlareClusterLayer(data, map, layerId, clusterProps: ClusterLayerProperties | ClusterLayerFromGraphics) {
    initFlareClusterLayer(data, map, clusterProps) {
        function isGraphics(item) {
            return item.graphics !== undefined;
        }
        if (isGraphics(clusterProps)) {
            let cp = clusterProps;
            if (cp.removeGraphicsLayersOnCreation) {
                let gl = this.map.findLayerById(cp.layerId);
                if (gl !== undefined)
                    this.map.remove(gl);
            }
        }
        const DEFAULT_SYMBOL = new this.EsriSimpleMarkerSymbol({
            size: (clusterProps.options && clusterProps.options.defaultMarkerSize) ? clusterProps.options && clusterProps.options.defaultMarkerSize : 6,
            color: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.default) ? clusterProps.options.colors.default : '#3B675E',
            outline: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.defaultOutline) ? new this.EsriSimpleLineSymbol({ color: clusterProps.options.colors.defaultOutline }) : null
        });
        const RENDERER = new this.EsriClassBreaksRenderer({
            defaultSymbol: DEFAULT_SYMBOL
        });
        const SM_SYMBOL = new this.EsriSimpleMarkerSymbol({ size: 22, outline: new this.EsriSimpleLineSymbol({ color: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.SMOutline) ? clusterProps.options.colors.SMOutline : [136, 225, 251, 0.8] }), color: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.SM) ? clusterProps.options.colors.SM : [136, 225, 251, 0.8] });
        const MD_SYMBOL = new this.EsriSimpleMarkerSymbol({ size: 24, outline: new this.EsriSimpleLineSymbol({ color: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.MDOutline) ? clusterProps.options.colors.MDOutline : [38, 78, 159, 0.8] }), color: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.MD) ? clusterProps.options.colors.MD : [38, 78, 159, 0.8] });
        const LG_SYMBOL = new this.EsriSimpleMarkerSymbol({ size: 28, outline: new this.EsriSimpleLineSymbol({ color: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.LGOutline) ? clusterProps.options.colors.LGOutline : [19, 31, 90, 0.8] }), color: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.LG) ? clusterProps.options.colors.LG : [19, 31, 90, 0.8] });
        const XL_SYMBOL = new this.EsriSimpleMarkerSymbol({ size: 32, outline: new this.EsriSimpleLineSymbol({ color: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.XLOutline) ? clusterProps.options.colors.XLOutline : [18, 33, 72, 0.8] }), color: (clusterProps.options && clusterProps.options.colors && clusterProps.options.colors.XL) ? clusterProps.options.colors.XL : [18, 33, 72, 0.8] });
        // const DEFAULT_SYMBOL = new this.EsriSimpleMarkerSymbol({
        //   size: 6,
        //   color: '#3B675E',
        //   outline: null
        // });
        // const RENDERER = new this.EsriClassBreaksRenderer({
        //   defaultSymbol: DEFAULT_SYMBOL
        // });
        // const SM_SYMBOL = new this.EsriSimpleMarkerSymbol({ size: 22, outline: new this.EsriSimpleLineSymbol({ color: [136, 225, 251, 0.8] }), color: [136, 225, 251, 0.8] });
        // const MD_SYMBOL = new this.EsriSimpleMarkerSymbol({ size: 24, outline: new this.EsriSimpleLineSymbol({ color: [38, 78, 159, 0.8] }), color: [38, 78, 159, 0.8] });
        // const LG_SYMBOL = new this.EsriSimpleMarkerSymbol({ size: 28, outline: new this.EsriSimpleLineSymbol({ color: [19, 31, 90, 0.8] }), color: [19, 31, 90, 0.8] });
        // const XL_SYMBOL = new this.EsriSimpleMarkerSymbol({ size: 32, outline: new this.EsriSimpleLineSymbol({ color: [18, 33, 72, 0.8] }), color: [18, 33, 72, 0.8] });
        const POPUP_TEMPLATE = new this.EsriPopupTemplate({
            title: clusterProps.popup.title,
            content: this._makePopupContent(clusterProps.popup.content),
            actions: clusterProps.popup.popupActionProperties ? clusterProps.popup.popupActionProperties : []
        });
        RENDERER.field = 'clusterCount';
        RENDERER.addClassBreakInfo(0, 19, SM_SYMBOL);
        RENDERER.addClassBreakInfo(20, 150, MD_SYMBOL);
        RENDERER.addClassBreakInfo(151, 1000, LG_SYMBOL);
        RENDERER.addClassBreakInfo(1001, Infinity, XL_SYMBOL);
        const OPTIONS = {
            id: clusterProps.layerId,
            displayFlares: false,
            clusterRenderer: RENDERER,
            singlePopupTemplate: POPUP_TEMPLATE,
            spatialReference: new this.EsriSpatialReference({ 'wkid': 4326 }),
            clusterRatio: (clusterProps.options != null && clusterProps.options.clusterRatio != null) ? clusterProps.options.clusterRatio : 75,
            clusterToScale: (clusterProps.options != null && clusterProps.options.clusterToScale != null) ? clusterProps.options.clusterToScale : 2000000,
            clusterAreaDisplay: '',
            data: data
        };
        const CLUSTER_LAYER = new this.fcl.FlareClusterLayer(OPTIONS);
        CLUSTER_LAYER.title = clusterProps.layerName;
        map.add(CLUSTER_LAYER);
    }
    ;
    _makePopupContent(content) {
        if (content.fieldAliases != null) { // IClusterPopupFields
            let _content = content;
            return [{
                    type: 'fields',
                    fieldInfos: _content.fields.map((field, index) => {
                        return {
                            fieldName: field,
                            label: _content.fieldAliases ? _content.fieldAliases[index] : _content.fields[index],
                            visible: true
                        };
                    })
                }];
        }
        else { // __esri.Content
            return content;
        }
    }
    createGraphicsLayerFromFeatures(featureCollection, wkid) {
        let feature;
        let graphic;
        let point;
        const GRAPHICS = [];
        const pointSymbol = {
            color: [31, 37, 90],
            outline: {
                color: [31, 37, 90]
            },
            size: 2,
            type: 'simple-marker',
        };
        for (feature of featureCollection) {
            let tempLONGLAT = [feature.geometry.x, feature.geometry.y];
            if (wkid !== 4326) {
                tempLONGLAT = this.webMerUtils.xyToLngLat(tempLONGLAT[0], tempLONGLAT[1]);
            }
            point = {
                type: 'point',
                longitude: tempLONGLAT[0],
                latitude: tempLONGLAT[1]
            };
            graphic = new this.EsriGraphic({
                geometry: point,
                symbol: pointSymbol,
                attributes: {}
            });
            let feat_attrs = Object.entries(feature.attributes);
            feat_attrs.forEach((key_val) => {
                graphic.attributes[key_val[0]] = key_val[1];
            });
            // fields.forEach((field: string) => {
            //   graphic.attributes[field] = feature.attributes[field]
            // });
            GRAPHICS.push(graphic);
        }
        return new this.EsriGraphicsLayer({
            id: 'graphicsLayer',
            graphics: GRAPHICS
        });
    }
    ;
    // const formatFeatures = (featureCollection, fields) => {
    //   let feature;
    //   let jsonFeature;
    //   const FORMATTED_FEATURES = [];
    //   for (feature of featureCollection) {
    //     if (feature.geometry !== null) {
    //       jsonFeature = {
    //         'x': feature.geometry.x,
    //         'y': feature.geometry.y
    //       };
    //       // add fields here
    //       fields.forEach((field: string) => {
    //         jsonFeature[field] = feature.attributes[field]
    //       });
    //       FORMATTED_FEATURES.push(jsonFeature);
    //     }
    //   }
    //   return FORMATTED_FEATURES;
    // };
    /**
     * Formats Graphics fields and adds popup actions
     * @param graphicsCollection
     * @param fields
     */
    graphicsCollectionToFormattedFeatures(graphicsCollection) {
        let graphic;
        let jsonFeature;
        const FORMATTED_FEATURES = [];
        for (graphic of graphicsCollection) {
            if (graphic.geometry !== null) {
                jsonFeature = Object.assign({ 'x': graphic.geometry.longitude, 'y': graphic.geometry.latitude }, graphic.attributes);
                // fields.forEach((field: string) => {
                //   jsonFeature[field] = graphic.attributes[field];
                // });
                FORMATTED_FEATURES.push(jsonFeature);
            }
        }
        return FORMATTED_FEATURES;
    }
    ;
    makeClusterLayersFromDefs(clusterProperty, map) {
        if (clusterProperty.layerToClusterType === ELayerType.GraphicsLayer) {
            let GRAPHICS_LAYER = map.findLayerById(clusterProperty.layerToClusterId);
            GRAPHICS_LAYER.visible = false; // visibility to False
            const GRAPHICS_DATA = this.graphicsCollectionToFormattedFeatures(GRAPHICS_LAYER.graphics);
            this.initFlareClusterLayer(GRAPHICS_DATA, map, clusterProperty);
        }
        else {
            let LAYER_TO_CLUSTER;
            if (clusterProperty.layerToClusterType === ELayerType.FeatureLayer) {
                // console.log("It's a FEATURE Layer");
                LAYER_TO_CLUSTER = map.findLayerById(clusterProperty.layerToClusterId);
                LAYER_TO_CLUSTER.visible = false; // visibility to False
            }
            else if (clusterProperty.layerToClusterType === ELayerType.MapImageLayer && clusterProperty.layerToClusterSublayerId) {
                // console.log("It's a MAP IMAGE Layer");
                let tempMapImgLyr = map.findLayerById(clusterProperty.layerToClusterId);
                let subLyr = tempMapImgLyr.findSublayerById(clusterProperty.layerToClusterSublayerId);
                subLyr.visible = false; // visibility to False
                LAYER_TO_CLUSTER = new this.EsriFeatureLayer({
                    id: "featureLayer",
                    url: subLyr.url
                });
            }
            this.getFeatures(map, LAYER_TO_CLUSTER, clusterProperty).then((featureCollection) => {
                const GRAPHICS_LAYER = this.createGraphicsLayerFromFeatures(featureCollection, LAYER_TO_CLUSTER.spatialReference.wkid);
                const GRAPHICS_DATA = this.graphicsCollectionToFormattedFeatures(GRAPHICS_LAYER.graphics.items);
                this.initFlareClusterLayer(GRAPHICS_DATA, map, clusterProperty);
            });
        }
    }
    curry_MakeClusterLayerFromGraphics(map) {
        return this.makeClusterLayerFromGraphics.bind(this, map);
    }
};
ClusterLayerService.ɵfac = function ClusterLayerService_Factory(t) { return new (t || ClusterLayerService)(); };
ClusterLayerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ClusterLayerService, factory: function (t) { return ClusterLayerService.ɵfac(t); }, providedIn: 'root' });
ClusterLayerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ClusterLayerService_Factory() { return new ClusterLayerService(); }, token: ClusterLayerService, providedIn: "root" });
ClusterLayerService = __decorate([ __metadata("design:paramtypes", [])
], ClusterLayerService);

let ExpandableWidgetControllerService = class ExpandableWidgetControllerService {
    constructor() {
    }
    createExpand(expandOptions, mapState) {
        return new Promise((res, rej) => {
            // if(this.Expand == null){ // Constructor not loaded yet
            //   esriLoader.loadModules(['esri/widgets/Expand']).then(([Expand]: [__esri.ExpandConstructor]) => {
            //     this.Expand = Expand;
            //     _ExpandCreator();
            //   });
            // }else{
            //   _ExpandCreator();
            // }
            esriLoader.loadModules(['esri/widgets/Expand']).then(([Expand]) => {
                this.Expand = Expand;
                _ExpandCreator.call(this);
            }).catch((err) => {
                console.error(err);
            });
            function _ExpandCreator() {
                let newExpand = new this.Expand({
                    expandIconClass: expandOptions.expandIconClass,
                    expandTooltip: expandOptions.expandTooltip,
                    view: expandOptions.view,
                    content: expandOptions.content
                });
                mapState.expandableWidgets.push(newExpand);
                // Register new Expand to handle open event 
                newExpand.watch('expanded', (isExpanded) => {
                    if (isExpanded)
                        this.eventOpenSingleExpand(newExpand, mapState.expandableWidgets);
                });
                res(newExpand);
            }
        });
    }
    eventOpenSingleExpand(expandToOpen, allExpands) {
        allExpands.forEach((expand) => {
            expand.collapse();
        });
        expandToOpen.expand();
    }
};
ExpandableWidgetControllerService.ɵfac = function ExpandableWidgetControllerService_Factory(t) { return new (t || ExpandableWidgetControllerService)(); };
ExpandableWidgetControllerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ExpandableWidgetControllerService, factory: function (t) { return ExpandableWidgetControllerService.ɵfac(t); }, providedIn: 'root' });
ExpandableWidgetControllerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ExpandableWidgetControllerService_Factory() { return new ExpandableWidgetControllerService(); }, token: ExpandableWidgetControllerService, providedIn: "root" });
ExpandableWidgetControllerService = __decorate([ __metadata("design:paramtypes", [])
], ExpandableWidgetControllerService);

let GeometryService = class GeometryService {
    constructor() { }
    loadEsriApi() {
        return new Promise((res, rej) => {
            esriLoader.loadModules([
                'esri/geometry/geometryEngine',
                'esri/geometry/support/webMercatorUtils'
            ]).then(([geometryEngine, webMercatorUtils]) => {
                this.utilGeometryEngine = geometryEngine;
                this.utilWebMercator = webMercatorUtils;
                res(true);
            }).catch((err) => {
                console.error("Geometry Service failed to Load Resources", err); // TODO Create Logging service for Map Library
                res(false);
            });
        });
    }
    /**
     * Creates a Planar Buffer geometry. Planar does not account for the curvature of the earth. So use this only
     * when using a projected coordinate system. http://desktop.arcgis.com/en/arcmap/10.3/guide-books/map-projections/about-projected-coordinate-systems.htm
     * So DON'T use this for spatial Refs of 4326, 3857, or 102100.
     * @param geometry
     * @param distance
     * @param unit - meters | feet | kilometers | miles | nautical-miles | yards
     * @param unionFinalResult - Determines whether the output geometries should be unioned into a single polygon
     */
    createPlanarBufferGeometry(geometry, distance, unit, unionFinalResult) {
        return this.utilGeometryEngine.buffer(geometry, distance, unit, unionFinalResult);
    }
    /**
     * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-geometryEngine.html#intersect
     */
    createIntersectGeometry(geomArr, intersected) {
        let returnGeom = this.utilGeometryEngine.intersect(geomArr, intersected);
        if (Array.isArray(returnGeom)) {
            return returnGeom;
        }
        else {
            return [returnGeom];
        }
    }
    /**
     * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-geometryEngine.html#geodesicBuffer
     */
    createGeodesicBufferGeometry(geometry, distance, unit) {
        return this.utilGeometryEngine.geodesicBuffer(geometry, distance, unit);
    }
    /**
     * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-geometryEngine.html#union
     */
    createUnionGeometry(geomArr) {
        return this.utilGeometryEngine.union(geomArr);
    }
    /**
     * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-geometryEngine.html#geodesicArea
     */
    getGeodesicArea(polygon, unit) {
        return this.utilGeometryEngine.geodesicArea(polygon, unit);
    }
    /**
     * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-geometryEngine.html#geodesicLength
     */
    getGeodesicLength(geometry, unit) {
        return this.utilGeometryEngine.geodesicLength(geometry, unit);
    }
    /**
     * Planar Area does not account for the curvature of the earth
     */
    getPlanarArea(polygon, unit) {
        return this.utilGeometryEngine.planarArea(polygon, unit);
    }
    /**
     * Planar length does not account for the curvature of the earth
     * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-geometryEngine.html#planarLength
     */
    getPlanarLength(geometry, unit) {
        return this.utilGeometryEngine.planarLength(geometry, unit);
    }
    /**
     * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-geometryEngine.html#nearestCoordinate
     */
    utilNearestCoordinate(geometry, inputpoint) {
        return this.utilGeometryEngine.nearestCoordinate(geometry, inputpoint);
    }
    /**
     * https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-support-webMercatorUtils.html#webMercatorToGeographic
     */
    convertWebMercatorToGeographic(geometry) {
        return this.utilWebMercator.webMercatorToGeographic(geometry);
    }
};
GeometryService.ɵfac = function GeometryService_Factory(t) { return new (t || GeometryService)(); };
GeometryService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: GeometryService, factory: function (t) { return GeometryService.ɵfac(t); }, providedIn: 'root' });
GeometryService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GeometryService_Factory() { return new GeometryService(); }, token: GeometryService, providedIn: "root" });
GeometryService = __decorate([ __metadata("design:paramtypes", [])
], GeometryService);

let PopupActionControllerService = class PopupActionControllerService {
    constructor() {
        /**
       * Deprecating this functionality in the Map Library. The more thought I give to this,
       * the more I'm convinced that we should not be doing this sort of thing in the
       * Map Library. What I mean is, we shouldn't be attempting to encapsulate (or write a better)
       * functionality **that is already avaliable in the ArcGIS JS API**. Here's why:
       *
       *  1. We are attempting to do better than the actual Esri JS API makers. This is
       *   somewhat unreasonable considering the fact that their full time job is to make this
       *   api and consider it's usability and quality, while we are just pursuing the Map Library
       *   as a side project.
       *
       *  2. We lose the ability for all users of the Map Library to reference
       *   the ArcGIS JS API documentation to solve their own problems. Like, if a Map Lib user
       *   is trying to make a PopupAction, and uses the utilities below and gets stuck, they
       *   can't reference the Esri Docs to solve their problem, and they can't google to solve it.
       *   We could potentially write better Docs for the Map Lib, for them to reference but that takes
       *   time and effort, and the benefits aren't worth it, considering the fact that the
       *   problem is already solved in the JS API. Users can already add PopupActions, they
       *   just need the knowledge of the Esri api. And if they don't have that knowledge,
       *   then there are many resources avaliable online for them to learn it.
       *
       * So what's the point of the Map Library? It's to write our own implementations of functionality
       * that is not currently in the Esri JS API. Good examples are our Elevation Profile widget, and
       * the Cluster Layer. These utilities are not avaliable through the API, and so it benefits
       * us to have a reuseable implementation of it in the Map Library that all Map Library
       * users can utilize, without having to implement it in their personal apps.
       *
       * Additionally, we can and should setup methods and processes that make common tasks easier.
       * An example is our configuration code to quickly setup various Map Widgets. This is valuable because
       * this is a process that users would have to do over and over again in the different apps
       * that they use maps in (and the different Maps in their Apps). So,
       * having this configuration easily avaliable to quickly get those
       * Map Widgets in place is useful, and does not go against what was said above (even though
       * these widgets are avaliable through the Esri JS API, and Map Lib users could just load
       * them and set them up themselves.)
       *
       *
       *
       */
        this.popupActionClickedSubject = new BehaviorSubject(null);
    }
    loadEsriApi() {
        return new Promise((res, rej) => {
            esriLoader.loadModules([
                'esri/core/Collection'
            ]).then(([Collection]) => {
                this.Collection = Collection;
                res(true);
            }).catch((err) => {
                console.error("Popup Action Service failed to Load Resources", err); // TODO Create Logging service for Map Library
                res(false);
            });
        });
    }
    makePopupActions(mapView, mi, popupActions) {
        if (popupActions == null || popupActions.length === 0)
            return;
        mi.popupActions = mi.popupActions.concat(popupActions);
        this._loopLayers.call(this, mapView, popupActions, 'add');
    }
    makePopupAction(mapView, mi, popupAction) {
        if (popupAction == null)
            return;
        mi.popupActions.push(popupAction);
        this._loopLayers.call(this, mapView, [popupAction], 'add');
    }
    removePopupAction(mapView, mi, popupActionId) {
        let popupActionToRemove = mi.popupActions.find((pa) => {
            return pa.popupActionProperties.id === popupActionId;
        });
        if (popupActionToRemove == null) {
            console.log(`No PopupAction of Id --- ${popupActionId} --- exists to be removed. Remove Failed.`);
            return;
        }
        mi.popupActions = mi.popupActions.filter((pa) => {
            return pa.popupActionProperties.id !== popupActionToRemove.popupActionProperties.id;
        });
        this._loopLayers.call(this, mapView, [popupActionToRemove], 'remove');
    }
    _loopLayers(mapView, popupActions, functionType) {
        // add custom popup actions
        let m = mapView.map.layers;
        for (let i = 0; i < m.items.length; i++) {
            // Feature Layer
            if (m.items[i].type === 'feature') {
                if (functionType === 'add') {
                    let arrA = [];
                    for (let j = 0; j < popupActions.length; j++) {
                        if (m.items[i].id === popupActions[j].layerId) {
                            arrA.push(popupActions[j]);
                        }
                    }
                    // if PA array on PopupTemplate is null, we have set something to it, so that the concat below works
                    if (m.items[i].popupTemplate.actions == null) {
                        m.items[i].popupTemplate.actions = [];
                    }
                    // Concat the existing PA array with the new one, and then assign that as the new PA array 
                    m.items[i].popupTemplate.actions = m.items[i].popupTemplate.actions.concat(arrA.map(l => l.popupActionProperties));
                }
                else { // remove
                    m.items[i].popupTemplate.actions = this._removePopupAction(m.items[i].popupTemplate.actions, popupActions[0]);
                }
            }
            // handle sublayers in a web map grouping (1 level)
            else if (m.items[i].type === 'map-image') {
                this._popupActionOnMapImageLayer(m.items[i], popupActions, functionType);
            }
            // Can't process Graphics layers. Their popupactions have to be added to individual graphics in the GraphicsLayer
            // else if (m.items[i].type === 'graphics'){
            // }
            else {
                for (let j = 0; j < popupActions.length; j++) {
                    if (m.items[i].id === popupActions[j].layerId) {
                        console.log(`Not handling Layer Type of --- ${m.items[i].type} --- for PopupActions. Action not added for id ${popupActions[j].popupActionProperties.id}.`);
                    }
                }
            }
        }
    }
    _popupActionOnMapImageLayer(mapImgLyr, popupActions, functionType) {
        if (mapImgLyr.sublayers !== null) {
            mapImgLyr.when(() => {
                for (let j = 0; j < popupActions.length; j++) {
                    if (mapImgLyr.id === popupActions[j].layerId) {
                        let subLayerLookingFor = mapImgLyr.findSublayerById(popupActions[j].sublayerId); // we are looking directly for the sublayer
                        if (subLayerLookingFor != null) {
                            if (subLayerLookingFor.popupTemplate.actions != null) {
                                if (functionType === 'add') {
                                    subLayerLookingFor.popupTemplate.actions.push(popupActions[j].popupActionProperties);
                                }
                                else { // remove
                                    subLayerLookingFor.popupTemplate.actions = this._removePopupAction(subLayerLookingFor.popupTemplate.actions, popupActions[0]);
                                }
                            }
                            else { // There's no actions Collection. Need to make one.
                                subLayerLookingFor.popupTemplate.actions = new this.Collection();
                                subLayerLookingFor.popupTemplate.actions.push(popupActions[j].popupActionProperties);
                            }
                        }
                    }
                }
            });
        }
    }
    _removePopupAction(pa_Collection, popupAction) {
        return pa_Collection.filter((item) => {
            return item.id !== popupAction.popupActionProperties.id;
        });
    }
    curry_makePopupAction(mapView, mapState) {
        return this.makePopupAction.bind(this, mapView, mapState);
    }
    curry_makePopupActions(mapView, mapState) {
        return this.makePopupActions.bind(this, mapView, mapState);
    }
    curry_removePopupAction(mapView, mapState) {
        return this.removePopupAction.bind(this, mapView, mapState);
    }
    handlePopupActionClickEvent(event, mapState) {
        let didEventHappen = false;
        let currPopupActions = mapState.popupActions;
        for (let i = 0; i < currPopupActions.length; i++) {
            if (currPopupActions[i].popupActionProperties.id === event.action.id) {
                didEventHappen = true;
            }
        }
        if (didEventHappen == true)
            this.popupActionClickedSubject.next(event);
    }
};
PopupActionControllerService.ɵfac = function PopupActionControllerService_Factory(t) { return new (t || PopupActionControllerService)(); };
PopupActionControllerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: PopupActionControllerService, factory: function (t) { return PopupActionControllerService.ɵfac(t); }, providedIn: 'root' });
PopupActionControllerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PopupActionControllerService_Factory() { return new PopupActionControllerService(); }, token: PopupActionControllerService, providedIn: "root" });
PopupActionControllerService = __decorate([ __metadata("design:paramtypes", [])
], PopupActionControllerService);

let ActionMapEventControllerService = class ActionMapEventControllerService {
    constructor(geomService, popupActionService) {
        this.geomService = geomService;
        this.popupActionService = popupActionService;
        // coords$ = new BehaviorSubject([]);
        this.snapping$ = new BehaviorSubject([]); // refactor to instanceState
    }
    /**
     * Changes ActiveClick type, sets active button color to orange, and all non-active buttons to white.
     *
     * @param map - Map
     * @param identifier - Can be the HtmlElement representing the button, or the Enum value off of EActiveClickType
     * @param mapState - MapState
     */
    setActiveClickType(map, identifier, mapState) {
        // console.log("IN setClickType");
        if (identifier === EActiveClickType.esri) {
            this.actionPopupState(map, false);
            mapState.ActiveClickType = EActiveClickType.esri;
        }
        else {
            this.actionPopupState(map, true);
        }
        mapState.actionButtonWidgets.forEach((triplet) => {
            if (identifier === triplet[0] || identifier === triplet[1]) {
                triplet[0].style.backgroundColor = "#f6c51b";
                mapState.ActiveClickType = triplet[1];
            }
            else { // reset button color to white
                if (triplet[0].style.backgroundColor === "#f6c51b" || triplet[0].style.backgroundColor === "rgb(246, 197, 27)") {
                    triplet[0].style.backgroundColor = "#ffffff";
                    triplet[2](); // invoke the reset Function
                }
                triplet[0].style.backgroundColor = "#ffffff";
            }
        });
    }
    /** Convenience method - special case of setActiveClickType */
    setClickTypeToEsri(map, mapState) {
        this.actionPopupState(map, false);
        mapState.ActiveClickType = EActiveClickType.esri;
        mapState.actionButtonWidgets.forEach((triplet) => {
            if (triplet[0].style.backgroundColor === "#f6c51b" || triplet[0].style.backgroundColor === "rgb(246, 197, 27)") { // Implies that it's currently active, and so we can run the reset
                triplet[0].style.backgroundColor = "#ffffff"; // signal that this button is no longer "active" before we invoke the reset (protects us from infinite recursion.... i think...)
                triplet[2](); // invoke the reset Function
            }
            triplet[0].style.backgroundColor = "#ffffff";
        });
    }
    eventPopupOnTriggerAction(mapView, mapInternalState) {
        mapView.popup.viewModel.on("trigger-action", (event) => {
            this.popupActionService.handlePopupActionClickEvent(event, mapInternalState);
        });
    }
    /**
     * Setup listeners and logic handlers for different Mouse events that happen on the MapView.
     * The Handlers, which decide what functions call, are based on the ActiveClickType at the
     * time of the mouse event.
     */
    setupMapViewEvents(mapView, mapOptions, mapInternalState) {
        this._setupClickEvents(mapView, mapOptions, mapInternalState);
        this._setupMoveOverEvents(mapView, mapOptions, mapInternalState);
    }
    /** Sets up MapView Click Events */
    _setupClickEvents(mapView, mapOptions, mapInternalState) {
        // handle click events
        mapView.on('click', (evt) => {
            if (mapInternalState.ActiveClickType === EActiveClickType.bingMaps || mapInternalState.ActiveClickType === EActiveClickType.googleMaps) {
                this.actionBingGoogle(mapOptions, mapInternalState.ActiveClickType, evt.mapPoint.latitude, evt.mapPoint.longitude);
            }
            else if (mapInternalState.ActiveClickType === EActiveClickType.coords) {
                mapInternalState.coords$.next([{ latitude: evt.mapPoint.latitude, longitude: evt.mapPoint.longitude }]);
                setTimeout(() => {
                    this.setClickTypeToEsri(mapView.map, mapInternalState);
                }, 500);
            }
            else if (mapInternalState.ActiveClickType === EActiveClickType.snapping) {
                let layer = mapView.map.findLayerById(mapOptions.mapEventSnapping.layerId);
                if (mapOptions.mapEventSnapping.sublayerId) {
                    let mil = layer;
                    let sublayer = mil.findSublayerById(mapOptions.mapEventSnapping.sublayerId);
                    this.actionFindClosestFeature(sublayer, evt.mapPoint);
                }
                else {
                    let fl = layer;
                    this.actionFindClosestFeature(fl, evt.mapPoint);
                }
            }
            if (mapInternalState.customHoverInfo.hoverInfoElement !== null) {
                mapInternalState.customHoverInfo.hoverInfoElement.style.visibility = 'hidden';
            }
        });
    }
    /** Sets up MapView MouseOver Events */
    _setupMoveOverEvents(mapView, mapOptions, mapInternalState) {
        // handle pointer move events (with a hitTest)
        mapView.on('pointer-move', (evt) => {
            if (mapOptions.mapEventGetGraphicOnHover) {
                this._getGraphicOnHover(event, mapView, mapInternalState);
            }
            if (mapInternalState.customHoverInfo.hoverInfoElement !== null) {
                mapView.hitTest(evt).then((response) => {
                    if (response.results.length) {
                        let infoText = 'Unnamed';
                        let CHInfoProps = mapInternalState.customHoverInfo.hoverInfoProperties;
                        for (let i = 0; i < CHInfoProps.length; i++) {
                            let fl = mapView.map.findLayerById(CHInfoProps[i].layerId);
                            if (fl) {
                                var graphic = response.results.filter((result) => {
                                    return result.graphic.layer === fl;
                                })[0].graphic;
                                if (graphic.attributes[CHInfoProps[i].fieldName] !== null && graphic.attributes[CHInfoProps[i].fieldName] !== '') {
                                    if (infoText === 'Unnamed')
                                        infoText = CHInfoProps[i].layerName + ': ' + graphic.attributes[CHInfoProps[i].fieldName];
                                    else
                                        infoText += ', ' + CHInfoProps[i].layerName + ': ' + graphic.attributes[CHInfoProps[i].fieldName];
                                }
                            }
                        }
                        mapInternalState.customHoverInfo.hoverInfoElement.style.visibility = 'visible';
                        mapInternalState.customHoverInfo.hoverInfoElement.innerHTML = infoText;
                    }
                });
            }
        });
    }
    actionBingGoogle(mapOptions, activeClick, latitude, longitude) {
        switch (activeClick) {
            case EActiveClickType.googleMaps:
                let coords = latitude + ',' + longitude;
                let openType = mapOptions.widgetGoogleMaps.launchAs360View ? 'pano' : 'map';
                window.open(`https://www.google.com/maps/@?api=1&map_action=${openType}&viewpoint=${coords}`);
                break;
            case EActiveClickType.bingMaps:
                let coords2 = latitude + '~' + longitude;
                let openType2 = mapOptions.widgetBingMaps.launchAs360View ? 'x' : 'b';
                window.open(`https://bing.com/maps/default.aspx?cp=${coords2}&lvl=20&style=${openType2}`);
                break;
        }
    }
    actionFindClosestFeature(fl, geometry) {
        // TODO: error handling
        let buffer = this.geomService.createGeodesicBufferGeometry([geometry], 500, "feet");
        let bufferGeo = buffer;
        const queryParams = fl.createQuery();
        queryParams.geometry = bufferGeo;
        let closestPoint;
        fl.queryFeatures(queryParams).then((results) => {
            results.features.forEach((element) => {
                let nearResults = this.geomService.utilNearestCoordinate(element.geometry, geometry);
                if (closestPoint == null) {
                    closestPoint = nearResults;
                }
                else if (nearResults.distance < closestPoint.distance) {
                    closestPoint = nearResults;
                }
            });
            // TODO: don't need an array - use obj
            this.snapping$.next([{ latitude: closestPoint.coordinate.latitude, longitude: closestPoint.coordinate.longitude }]);
        });
    }
    actionPopupState(map, disable) {
        function _handleSublayers(setPopup, sublayers) {
            for (let j = 0; j < sublayers.items.length; j++) {
                try {
                    sublayers.items[j].popupEnabled = setPopup;
                    if (sublayers.items[j].sublayers !== null) {
                        _handleSublayers(setPopup, sublayers.items[j].sublayers);
                    }
                }
                catch (_a) { }
            }
        }
        let m = map;
        if (disable === true) {
            for (let i = 0; i < m.layers.items.length; i++) {
                let x = m.layers.items[i];
                if (x.type === 'feature')
                    x.popupEnabled = false;
                else if (x.type === 'map-image') {
                    if (x.sublayers !== null) {
                        _handleSublayers(false, x.sublayers);
                    }
                }
            }
        }
        else {
            for (let i = 0; i < m.layers.items.length; i++) {
                let x = m.layers.items[i];
                if (x.type === 'feature')
                    x.popupEnabled = true;
                else if (x.type === 'map-image') {
                    if (x.sublayers !== null) {
                        _handleSublayers(true, x.sublayers);
                    }
                }
            }
        }
    }
    _getGraphicOnHover(event, mapView, mapInternalState) {
        mapView.hitTest(event).then((response) => {
            if (response.results.length) {
                // console.log(response)
                mapInternalState.graphicOnHover.next(response.results);
            }
            else {
                mapInternalState.graphicOnHover.next(null);
            }
        });
    }
    curry_SetClickTypeToEsri(map, mapState) {
        return this.setClickTypeToEsri.bind(this, map, mapState);
    }
};
ActionMapEventControllerService.ɵfac = function ActionMapEventControllerService_Factory(t) { return new (t || ActionMapEventControllerService)(ɵngcc0.ɵɵinject(GeometryService), ɵngcc0.ɵɵinject(PopupActionControllerService)); };
ActionMapEventControllerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ActionMapEventControllerService, factory: function (t) { return ActionMapEventControllerService.ɵfac(t); }, providedIn: 'root' });
ActionMapEventControllerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ActionMapEventControllerService_Factory() { return new ActionMapEventControllerService(ɵɵinject(GeometryService), ɵɵinject(PopupActionControllerService)); }, token: ActionMapEventControllerService, providedIn: "root" });
ActionMapEventControllerService = __decorate([ __metadata("design:paramtypes", [GeometryService,
        PopupActionControllerService])
], ActionMapEventControllerService);

let LayerManagerService = class LayerManagerService {
    constructor() { }
    loadEsriApi() {
        return new Promise((res, rej) => {
            esriLoader.loadModules([
                'esri/layers/FeatureLayer',
                'esri/layers/MapImageLayer',
                'esri/layers/GraphicsLayer'
            ]).then(([FeatureLayer, MapImageLayer, GraphicsLayer]) => {
                this.FeatureLayer = FeatureLayer;
                this.MapImageLayer = MapImageLayer;
                this.GraphicsLayer = GraphicsLayer;
                res(true);
            }).catch((err) => {
                console.error("Layer Manager failed to Load Resources", err); // TODO Create Logging service for Map Library
                res(false);
            });
        });
    }
    addFeatureLayers(map, featureLayers) {
        let arr = [];
        /* const labelClass: any = {
          labelExpressionInfo: { expression: "$feature.MASTER_INTERSECTION_ID" },
          symbol: {
            type: "text",  // autocasts as new TextSymbol()
            color: "black",
            haloSize: 1,
            haloColor: "white"
          }
        }; */
        for (let i = 0; i < featureLayers.length; i++) {
            let x = featureLayers[i];
            let y = new this.FeatureLayer({
                url: x.url,
                id: x.id,
                title: x.title,
                visible: x.visible,
                //labelingInfo: labelClass,
                //labelsVisible: true,
                popupTemplate: x.popupTemplate
            });
            arr.push(y);
        }
        map.addMany(arr);
    }
    addMapImageLayers(map, mapImageLayers) {
        let arr = [];
        for (let i = 0; i < mapImageLayers.length; i++) {
            let x = mapImageLayers[i];
            let y = new this.MapImageLayer({
                url: x.url,
                id: x.id,
                title: x.title,
                visible: x.visible,
                sublayers: x.sublayers
            });
            arr.push(y);
        }
        map.addMany(arr);
    }
    addGraphicsLayers(map, graphicsLayers) {
        let graphicsLyrs = graphicsLayers.map((defs) => {
            return new this.GraphicsLayer(defs);
        });
        map.addMany(graphicsLyrs);
        return graphicsLyrs;
    }
    curry_addGraphicsLayers(map) {
        return this.addGraphicsLayers.bind(this, map);
    }
};
LayerManagerService.ɵfac = function LayerManagerService_Factory(t) { return new (t || LayerManagerService)(); };
LayerManagerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LayerManagerService, factory: function (t) { return LayerManagerService.ɵfac(t); }, providedIn: 'root' });
LayerManagerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LayerManagerService_Factory() { return new LayerManagerService(); }, token: LayerManagerService, providedIn: "root" });
LayerManagerService = __decorate([ __metadata("design:paramtypes", [])
], LayerManagerService);

let SketchViewModelMakerService = class SketchViewModelMakerService {
    constructor() { }
    loadEsriApi() {
        return new Promise((res, rej) => {
            esriLoader.loadModules([
                'esri/widgets/Sketch/SketchViewModel',
                'esri/layers/GraphicsLayer'
            ]).then(([SketchViewModel, GraphicsLayer]) => {
                this.SketchViewModel = SketchViewModel;
                this.GraphicsLayer = GraphicsLayer;
                res(true);
            }).catch((err) => {
                console.error("SVM Maker failed to Load Resources", err); // TODO Create Logging service for Map Library
                res(false);
            });
        });
    }
    /** Make Multiple SVMs for a particular graphicsLayer  */
    makeSketchViewModels(mapView, internalState, graphicsLyr, sketchViewModelDefs) {
        sketchViewModelDefs.forEach((SVM_Def) => {
            this.makeSketchViewModel(mapView, internalState, graphicsLyr, SVM_Def);
        });
    }
    /** Make Single SVM for a particular graphicsLayer  */
    makeSketchViewModel(mapView, internalState, graphicsLyr, sketchViewModelDef) {
        let SVM = new this.SketchViewModel({
            layer: graphicsLyr,
            view: mapView
        });
        // SVM.on('create', (event) => {
        //   if(event.state === 'complete'){
        //     internalState.SVM_ResultGraphic_Subject.next([event.graphic, sketchViewModelDef.uniqueId]);
        //   }
        // });
        if (sketchViewModelDef.symbols != null && sketchViewModelDef.symbols.point != null)
            SVM.pointSymbol = sketchViewModelDef.symbols.point;
        if (sketchViewModelDef.symbols != null && sketchViewModelDef.symbols.polyline != null)
            SVM.polylineSymbol = sketchViewModelDef.symbols.polyline;
        if (sketchViewModelDef.symbols != null && sketchViewModelDef.symbols.polygon != null)
            SVM.polygonSymbol = sketchViewModelDef.symbols.polygon;
        internalState.sketchViewModels.push([SVM, sketchViewModelDef.uniqueId]);
        return SVM;
    }
    getSketchViewModel(internalState, uniqueId) {
        let myPairing = internalState.sketchViewModels.find((pairing) => {
            return uniqueId === pairing[1];
        });
        if (myPairing == null) {
            this._cannotFindSVMMsg(uniqueId);
            return null;
        }
        return myPairing[0];
    }
    /**
     * Returns sketchViewModels associated with the given graphicslayer. Returns as a pairing between the SVM
     * and the unique ID associated with it
     * @param internalState
     * @param graphicsLyr
     */
    getSketchViewModelForGraphicsLyr(internalState, graphicsLyr) {
        return internalState.sketchViewModels.filter((pairing) => {
            return pairing[0].layer.id === graphicsLyr.id;
        });
    }
    /**
     * Destorys the indicated SVM and removes it from the internal state array
     */
    destroySketchViewModel(internalState, uniqueId) {
        let SVMPairing = internalState.sketchViewModels.find((pairing) => {
            return pairing[1] === uniqueId;
        });
        if (SVMPairing == null) {
            // console.log("Map Library Error: SVM you are trying to destroy does not exist.");
            return; // No SVM was found
        }
        let SVM = SVMPairing[0];
        SVM.destroy();
        internalState.sketchViewModels = internalState.sketchViewModels.filter((pairing) => {
            return pairing[1] != uniqueId;
        });
    }
    // doActionSketchViewModel(internalState: IMapInternalState, uniqueId: string, action: SVM_Actions, extraActionOptions?: createOptions | updateOptions){
    //   let SVM:__esri.SketchViewModel = this.getSketchViewModel(internalState, uniqueId);
    //   if(SVM == null){
    //     this._cannotFindSVMMsg(uniqueId);
    //     return null;
    //   }
    //   switch(action) {
    //     case SVM_Actions.cancel:
    //       SVM.cancel();
    //       break;
    //     case SVM_Actions.complete:
    //       SVM.complete();
    //       break;
    //     case SVM_Actions.create:
    //       if(extraActionOptions != null && (<createOptions>extraActionOptions).createOptions != null ){
    //         let opts:createOptions = <createOptions>extraActionOptions;
    //         SVM.create(opts.tool, opts.createOptions);
    //       }else{
    //         console.log(`Create options not defined properly for Create operation.`);
    //       }
    //       break;
    //     case SVM_Actions.redo:
    //       SVM.redo();
    //       break;
    //     case SVM_Actions.reset:
    //       SVM.reset();
    //       break;
    //     case SVM_Actions.undo:
    //       SVM.undo();
    //       break;
    //     case SVM_Actions.update:
    //       if(extraActionOptions != null && (<updateOptions>extraActionOptions).updateOptions != null ){
    //         let opts:updateOptions = <updateOptions>extraActionOptions;
    //         SVM.update(opts.graphics, opts.updateOptions);
    //       }else{
    //         console.log(`Update options not defined properly for Update operation.`);
    //       }
    //       break;
    //     default:
    //       console.log(`Action - ${action} - is not handled.`)
    //   }
    // }
    curry_makeSketchViewModel(mapView, internalState) {
        return this.makeSketchViewModel.bind(this, mapView, internalState);
    }
    curry_getSketchViewModel(internalState) {
        return this.getSketchViewModel.bind(this, internalState);
    }
    curry_getSVMsForGraphicsLyr(internalState) {
        return this.getSketchViewModelForGraphicsLyr.bind(this, internalState);
    }
    curry_destroySketchViewModel(internalState) {
        return this.destroySketchViewModel.bind(this, internalState);
    }
    // curry_doActionSketchViewModel(internalState: IMapInternalState) : (uniqueId: string, action: SVM_Actions, extraActionOptions?: createOptions | updateOptions) => void {
    //   return this.doActionSketchViewModel.bind(this, internalState);
    // }
    _cannotFindSVMMsg(uniqueId) {
        console.log(`SVM ID: ${uniqueId} is not recognized`);
    }
};
SketchViewModelMakerService.ɵfac = function SketchViewModelMakerService_Factory(t) { return new (t || SketchViewModelMakerService)(); };
SketchViewModelMakerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SketchViewModelMakerService, factory: function (t) { return SketchViewModelMakerService.ɵfac(t); }, providedIn: 'root' });
SketchViewModelMakerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SketchViewModelMakerService_Factory() { return new SketchViewModelMakerService(); }, token: SketchViewModelMakerService, providedIn: "root" });
SketchViewModelMakerService = __decorate([ __metadata("design:paramtypes", [])
], SketchViewModelMakerService);

let ElevationProfileService = class ElevationProfileService {
    constructor(SVM_Service, geomService, mapEventService) {
        this.SVM_Service = SVM_Service;
        this.geomService = geomService;
        this.mapEventService = mapEventService;
        this.elevProfGeoprocUrl = "https://elevation.arcgis.com/arcgis/rest/services/Tools/ElevationSync/GPServer/Profile";
        // NOTE THAT this service is a singleton - SO ALL MAPS SHARE THESE AS STATE(and the graphics layer and SVM instances created here)
        // This shouldn't be that big of a deal, cause these only matter when an operation is actually being performed, but it's worth noting.
        // Also, my intention is to make this an internal map Widget, all self contained in the MAP LIB api. So when that happens, this state sharing
        // probably won't matter that much.
        this.$elevProfGraphic = new BehaviorSubject(null);
        this.$elevProfStatus = new BehaviorSubject(null);
        this.SVMUniqueId = "elevProfSVM";
    }
    loadEsriApi() {
        return new Promise((res, rej) => {
            esriLoader.loadModules([
                'esri/layers/GraphicsLayer',
                'esri/tasks/Geoprocessor',
                'esri/tasks/support/FeatureSet',
                'esri/Graphic',
                'esri/request'
            ]).then(([GraphicsLayer, Geoprocessor, FeatureSet, Graphic, request]) => {
                this.GraphicsLayer = GraphicsLayer;
                this.utilGeoprocessorElevationProfile = new Geoprocessor({ url: this.elevProfGeoprocUrl });
                this.FeatureSet = FeatureSet;
                this.Graphic = Graphic;
                this.esriRequest = request;
                res(true);
            }).catch((err) => {
                console.error("Map Lib Error: Elevation Prof Service failed to Load Resources", err); // TODO Create Logging service for Map Library
                rej(err);
            });
        });
    }
    startSketch(mapView, mapState) {
        // if exists then destroy
        if (this.elevProfGLayer != null)
            this.endSketch(mapView, mapState);
        this.elevProfGLayer = new this.GraphicsLayer({
            listMode: "hide",
            id: "elevProfGLayer"
        });
        mapView.map.add(this.elevProfGLayer);
        let elevProfSVM = this.SVM_Service.makeSketchViewModel(mapView, mapState, this.elevProfGLayer, {
            uniqueId: this.SVMUniqueId,
            symbols: {
                polyline: { type: "simple-line", width: 2.75, color: [255, 170, 0, 1] }
            }
        });
        elevProfSVM.create('polyline');
        this.createListener = elevProfSVM.on('create', (event) => {
            if (event.state === "complete") {
                this.$elevProfGraphic.next(event.graphic);
                this.runElevProf(event.graphic.geometry, mapView, mapState);
            }
        });
    }
    /**
     * This resets the Current Sketch in progress. NOTE: This function can be called
     * as many times as you want (at anytime), and things won't error out.
     * fromActionButtonReset is kinda a hacky way of making this work. When this method
     * is called from the MapActionEventService, we want it to not trigger the ClickType to Esri, because
     * that whole call from there is in the context of this ElevProf operation needing to be reset BECAUSE
     * ANOTHER ACTION MAP BUTTON HAS BEEN CLICK, and so we don't want to set click type to Esri, because
     * that would unselect the Action Map Button that was just clicked..... I know, it's hacky. sry dude...
     */
    endSketch(mapView, mapState, fromActionButtonReset) {
        if (this.elevProfGLayer != null) {
            mapView.map.remove(this.elevProfGLayer);
            this.elevProfGLayer.destroy();
            this.elevProfGLayer = null;
        }
        if (this.createListener != null) {
            this.createListener.remove();
            this.createListener = null;
        }
        this.SVM_Service.destroySketchViewModel(mapState, this.SVMUniqueId);
        // this.$elevProfGraphic.next(null);
        // this.$elevProfStatus.next(null);
        if (!fromActionButtonReset) {
            this.mapEventService.setClickTypeToEsri(mapView.map, mapState);
        }
    }
    runElevProf(polyline, mapView, mapState) {
        this.$elevProfStatus.next({ status: "processing", results: null });
        let webMercatorPolyline, samplingDistance;
        ({ webMercatorPolyline, samplingDistance } = this.prepElevationProfile(polyline, 199)); // object destructuring assignment
        this.geoprocessingElevationProfile(webMercatorPolyline, samplingDistance).then((res) => {
            this.$elevProfStatus.next({ status: "succeeded", results: this.processElevationProfile(res.data.results, samplingDistance) });
            this.endSketch(mapView, mapState);
        }).catch((err) => {
            this.$elevProfStatus.next({ status: "failed", results: null });
            console.error(err);
        });
    }
    /** Initial Setup for Elevation Prof Geoproc Request */
    prepElevationProfile(geometry, samplingPointCount) {
        const webMercatorPolyline = (geometry.spatialReference.isGeographic ? this.geomService.utilWebMercator.geographicToWebMercator(geometry) : geometry);
        const profileLengthMeters = this.geomService.getGeodesicLength(webMercatorPolyline, 'meters');
        const samplingDistance = (profileLengthMeters / samplingPointCount);
        return {
            webMercatorPolyline: webMercatorPolyline,
            samplingDistance: samplingDistance
        };
    }
    /** Preform Elevation Prof Geoproc Request */
    geoprocessingElevationProfile(webMercatorPolyline, samplingDistance) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("ELEV PROF BREAK");
            const inputProfileGraphic = new this.Graphic({
                geometry: webMercatorPolyline,
                symbol: null,
                attributes: {
                    OID: 1
                }
            });
            const inputLineFeatures = new this.FeatureSet(); // Feature Set
            inputLineFeatures.spatialReference = { wkid: 102100 };
            inputLineFeatures.geometryType = 'polyline';
            inputLineFeatures.features = [inputProfileGraphic];
            inputLineFeatures.fields = [
                {
                    'name': 'OID',
                    'type': 'oid',
                    'alias': 'OID'
                }
            ];
            return yield this.esriRequest(`${this.elevProfGeoprocUrl}/execute?f=json`, {
                query: {
                    'InputLineFeatures': inputLineFeatures,
                    'ProfileIDField': 'OID',
                    'DEMResolution': 'FINEST',
                    'MaximumSampleDistance': samplingDistance,
                    'MaximumSampleDistanceUnits': 'Meters',
                    'returnZ': true,
                    'returnM': true
                }
            });
            // NOTE: with the update to 4.13, this is no longer passing the returnZ, and returnM to the 
            // GP Task, and therefore those aren't coming back to use. Going to do this with
            // a straight EsriRequest call instead.
            // return await this.utilGeoprocessorElevationProfile.execute({
            //   'InputLineFeatures': inputLineFeatures,
            //   'ProfileIDField': 'OID',
            //   'DEMResolution': 'FINEST',
            //   'MaximumSampleDistance': samplingDistance,
            //   'MaximumSampleDistanceUnits': 'Meters'
            // }, {
            //   query: {
            //     'returnZ': true,
            //     'returnM': true
            //   }
            // });
        });
    }
    /** Process Elevation Prof Geoproc Request's Response data */
    processElevationProfile(data, samplingDistance) {
        if (data.length > 0) {
            const profileOutput = data[0].value;
            if (profileOutput.features.length > 0) {
                const profileFeature = profileOutput.features[0];
                const profileGeometry = profileFeature.geometry;
                const allElevations = [];
                const allDistances = [];
                if (profileGeometry.paths.length > 0) {
                    for (let i = 0; i < profileGeometry.paths.length; i++) {
                        let paths = profileGeometry.paths[i];
                        for (let j = 0; j < paths.length; j++) {
                            let points = paths[j];
                            const elevationInfo = {
                                x: ((points.length > 3) ? points[3] : (j * samplingDistance)),
                                y: ((points.length > 2) ? points[2] : 0.0),
                                pathIdx: i,
                                pointIdx: j
                            };
                            allElevations.push(elevationInfo);
                            allDistances.push(elevationInfo.x);
                        }
                    }
                    return {
                        geometry: profileGeometry,
                        elevations: allElevations,
                        distances: allDistances,
                        samplingDistance: samplingDistance
                    };
                }
                else
                    return null;
            }
            else
                return null;
        }
        else
            return null;
    }
};
ElevationProfileService.ɵfac = function ElevationProfileService_Factory(t) { return new (t || ElevationProfileService)(ɵngcc0.ɵɵinject(SketchViewModelMakerService), ɵngcc0.ɵɵinject(GeometryService), ɵngcc0.ɵɵinject(ActionMapEventControllerService)); };
ElevationProfileService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ElevationProfileService, factory: function (t) { return ElevationProfileService.ɵfac(t); }, providedIn: "root" });
ElevationProfileService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ElevationProfileService_Factory() { return new ElevationProfileService(ɵɵinject(SketchViewModelMakerService), ɵɵinject(GeometryService), ɵɵinject(ActionMapEventControllerService)); }, token: ElevationProfileService, providedIn: "root" });
ElevationProfileService = __decorate([ __metadata("design:paramtypes", [SketchViewModelMakerService,
        GeometryService,
        ActionMapEventControllerService])
], ElevationProfileService);

let LoadWidgetsHelperService = class LoadWidgetsHelperService {
    constructor() { }
    loadWidgetConstructors(mi) {
        let pairings = [];
        // Decide which to load in Esri Loader.
        this.decideToInclude(mi.options.widgetAreaMeasurement, ['esri/widgets/AreaMeasurement2D', 'AreaMeasurement2D'], pairings);
        this.decideToInclude(mi.options.widgetBasemapGallery, ['esri/widgets/BasemapGallery', 'BasemapGallery'], pairings);
        this.decideToInclude(mi.options.widgetBasemapToggle, ['esri/widgets/BasemapToggle', 'BasemapToggle'], pairings);
        this.decideToInclude(mi.options.widgetBookmarks, ['esri/widgets/Bookmarks', 'Bookmarks'], pairings);
        this.decideToInclude(mi.options.widgetCoordinateConversion, ['esri/widgets/CoordinateConversion', 'CoordinateConversion'], pairings);
        this.decideToInclude(mi.options.widgetDistanceMeasurement, ['esri/widgets/DistanceMeasurement2D', 'DistanceMeasurement2D'], pairings);
        this.decideToInclude(mi.options.widgetFullscreen, ['esri/widgets/Fullscreen', 'Fullscreen'], pairings);
        this.decideToInclude(mi.options.widgetHome, ['esri/widgets/Home', 'Home'], pairings);
        this.decideToInclude(mi.options.widgetLayerList, ['esri/widgets/LayerList', 'LayerList'], pairings);
        this.decideToInclude(mi.options.widgetLegend, ['esri/widgets/Legend', 'Legend'], pairings);
        this.decideToInclude(mi.options.widgetPrint, ['esri/widgets/Print', 'Print'], pairings);
        this.decideToInclude(mi.options.widgetScaleBar, ['esri/widgets/ScaleBar', 'ScaleBar'], pairings);
        this.decideToInclude(mi.options.widgetSearch, ['esri/widgets/Search', 'Search'], pairings);
        return new Promise((res, rej) => {
            esriLoader.loadModules(pairings.map(pair => pair[0])).then((myLoadedModules) => {
                // Widget Constructors Assignment
                myLoadedModules.forEach((loadedModule, index) => {
                    this[pairings[index][1]] = loadedModule; // assigns to the class variable specified in the pairing.
                });
                res(true);
            }).catch((err) => {
                console.error("Map Service failed to load widget resources", err);
                res(false);
            });
        });
    }
    decideToInclude(widgetProps, pair, collector) {
        if (widgetProps != null) {
            collector.push(pair);
        }
    }
};
LoadWidgetsHelperService.ɵfac = function LoadWidgetsHelperService_Factory(t) { return new (t || LoadWidgetsHelperService)(); };
LoadWidgetsHelperService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LoadWidgetsHelperService, factory: function (t) { return LoadWidgetsHelperService.ɵfac(t); }, providedIn: 'root' });
LoadWidgetsHelperService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LoadWidgetsHelperService_Factory() { return new LoadWidgetsHelperService(); }, token: LoadWidgetsHelperService, providedIn: "root" });
LoadWidgetsHelperService = __decorate([ __metadata("design:paramtypes", [])
], LoadWidgetsHelperService);

let MapService = class MapService {
    constructor(clusterLayerService, geomService, expandService, layerManager, sketchViewModelService, mapEventService, popupActionService, elevationProfileService, widgetLoadHelper) {
        this.clusterLayerService = clusterLayerService;
        this.geomService = geomService;
        this.expandService = expandService;
        this.layerManager = layerManager;
        this.sketchViewModelService = sketchViewModelService;
        this.mapEventService = mapEventService;
        this.popupActionService = popupActionService;
        this.elevationProfileService = elevationProfileService;
        this.widgetLoadHelper = widgetLoadHelper;
        this.command$ = new BehaviorSubject(null);
        this.extents$ = new BehaviorSubject([]); // todo
        this.stationary$ = new BehaviorSubject({}); // todo
    }
    loadScript() {
        return __awaiter(this, void 0, void 0, function* () {
            /// Load Arcgis api CSS
            loadCss("" + JS_API_VERSION);
            /// Load Arcgis api JS
            let options = {};
            // options.url = `https://js.arcgis.com/${JS_API_VERSION}/`;
            options.version = "" + JS_API_VERSION;
            options.dojoConfig = DOJO_CONFIG;
            console.log(options);
            let res;
            if (!esriLoader.isLoaded()) {
                res = yield esriLoader.loadScript(options);
            }
            /// Load other services' arcgis packages
            yield this.allowOtherServicesToLoadApi();
            return res;
        });
    }
    ;
    /**
     * Tells esri loaders in other services when they can load.
     * Otherwise they would load different versions of api if they load first.
     *
     * Also Initializes Esri Api Constructors for use in this service
     */
    allowOtherServicesToLoadApi() {
        return new Promise((res, rej) => {
            let promArr = [];
            promArr.push(this.geomService.loadEsriApi());
            promArr.push(this.layerManager.loadEsriApi());
            promArr.push(this.sketchViewModelService.loadEsriApi());
            promArr.push(this.popupActionService.loadEsriApi());
            promArr.push(this.elevationProfileService.loadEsriApi());
            promArr.push(this.loadMapServiceEsriConstructors.call(this));
            Promise.all(promArr).then(() => {
                res();
            }).catch((err) => {
                console.error("Something Failed in Loading API Resources", err);
            });
        });
    }
    loadMapServiceEsriConstructors() {
        return new Promise((res, rej) => {
            esriLoader.loadModules([
                'esri/Graphic',
                'esri/geometry/Point',
                'esri/geometry/Polygon',
                'esri/geometry/Polyline',
                'esri/geometry/SpatialReference',
                'esri/tasks/GeometryService',
                'esri/tasks/QueryTask',
                'esri/tasks/support/FeatureSet',
                'esri/tasks/support/ProjectParameters',
                'esri/request'
            ]).then(([Graphic, Point, Polygon, Polyline, SpatialReference, GeometryService, QueryTask, FeatureSet, ProjectParameters, esriRequest]) => {
                // Tasks
                this.taskGeometryService = GeometryService;
                this.taskProjectParameters = ProjectParameters;
                this.taskQueryTask = QueryTask;
                // Instance Constructors
                this.instFeatureSet = FeatureSet;
                this.instGraphic = Graphic;
                this.instPoint = Point;
                this.instPolygon = Polygon;
                this.instPolyline = Polyline;
                this.instSpatialReference = SpatialReference;
                this.esriRequest = esriRequest;
                res(true);
            }).catch((err) => {
                console.error("Map Service failed to load resources", err);
                res(false);
            });
        });
    }
    createMapView(mapType, mapProperties, webMapProperties, mapViewProperties, mapDom) {
        return __awaiter(this, void 0, void 0, function* () {
            return esriLoader.loadModules([
                'esri/Map',
                'esri/WebMap',
                'esri/views/MapView'
            ]).then(([Map, WebMap, MapView]) => {
                let map;
                switch (mapType) {
                    case EMapType.WebMap:
                        map = new WebMap(webMapProperties);
                        break;
                    default:
                        map = new Map(mapProperties);
                        break;
                }
                if (!mapViewProperties.container)
                    mapViewProperties.container = mapDom;
                if (!mapViewProperties.map)
                    mapViewProperties.map = map;
                let mapView = new MapView(mapViewProperties);
                // this.setMapViewInState(mapView);
                return mapView;
            });
        });
    }
    // setMapViewInState(mapView: __esri.MapView){
    //   this.internalStateService.setMapView(mapView);
    // }
    configMapInstance(mi, mapView) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.widgetLoadHelper.loadWidgetConstructors(mi);
            // collect all the reference-able widgets that get loaded so that we can provide a reference
            // to them in instanceUtils to allow users to get work with them after they've been loaded 
            const loadedWidgets = {};
            // Async Promises Collector Array
            let asyncWidgets = [];
            /////////////// Initialize Layers /////////////////////////////////
            if (mi.options.lyrsDefFeatureLyr !== null && mi.options.lyrsDefFeatureLyr.length !== 0)
                this.layerManager.addFeatureLayers(mapView.map, mi.options.lyrsDefFeatureLyr);
            if (mi.options.lyrsDefMapImageLyr !== null && mi.options.lyrsDefMapImageLyr.length !== 0)
                this.layerManager.addMapImageLayers(mapView.map, mi.options.lyrsDefMapImageLyr);
            if (mi.options.lyrsDefGraphicsLyr !== null && mi.options.lyrsDefGraphicsLyr.length !== 0)
                this.layerManager.addGraphicsLayers(mapView.map, mi.options.lyrsDefGraphicsLyr);
            if (mi.options.lyrsDefClusterLyr !== null && mi.options.lyrsDefClusterLyr.length !== 0)
                this.clusterLayerService.loadClusterLayers(mapView.map, mi.options.lyrsDefClusterLyr);
            /////////////// Initialize Widgets /////////////////////////////////
            // Init async - Esri Widgets
            if (mi.options.widgetAreaMeasurement !== null)
                asyncWidgets.push(this.asyncLoadWidget(loadedWidgets, "AreaMeasurement2D", this.addWidgetAreaMeasurement.bind(this, mapView, mi.options.widgetAreaMeasurement, mi.internalState)));
            if (mi.options.widgetBasemapGallery !== null)
                asyncWidgets.push(this.asyncLoadWidget(loadedWidgets, "BasemapGallery", this.addWidgetBasemapGallery.bind(this, mapView, mi.options.widgetBasemapGallery, mi.internalState)));
            if (mi.options.widgetBookmarks !== null)
                asyncWidgets.push(this.asyncLoadWidget(loadedWidgets, "Bookmarks", this.addWidgetBookmarks.bind(this, mapView, mi.options.widgetBookmarks, mi.internalState)));
            if (mi.options.widgetCoordinateConversion !== null)
                asyncWidgets.push(this.asyncLoadWidget(loadedWidgets, "CoordinateConversion", this.addWidgetCoordinateConversion.bind(this, mapView, mi.options.widgetCoordinateConversion, mi.internalState)));
            if (mi.options.widgetDistanceMeasurement !== null)
                asyncWidgets.push(this.asyncLoadWidget(loadedWidgets, "DistanceMeasurement2D", this.addWidgetDistanceMeasurement.bind(this, mapView, mi.options.widgetDistanceMeasurement, mi.internalState)));
            if (mi.options.widgetLayerList !== null)
                asyncWidgets.push(this.asyncLoadWidget(loadedWidgets, "LayerList", this.addWidgetLayerList.bind(this, mapView, mi.options.widgetLayerList, mi.internalState)));
            if (mi.options.widgetLegend !== null)
                asyncWidgets.push(this.asyncLoadWidget(loadedWidgets, "Legend", this.addWidgetLegend.bind(this, mapView, mi.options.widgetLegend, mi.internalState)));
            if (mi.options.widgetPrint !== null)
                asyncWidgets.push(this.asyncLoadWidget(loadedWidgets, "Print", this.addWidgetPrint.bind(this, mapView, mi.options.widgetPrint, mi.internalState)));
            // Init sync - Esri Widgets
            if (mi.options.widgetBasemapToggle !== null)
                loadedWidgets.BasemapToggle = this.addWidgetBasemapToggle(mapView, mi.options.widgetBasemapToggle);
            if (mi.options.widgetFullscreen !== null)
                loadedWidgets.Fullscreen = this.addWidgetFullscreen(mapView, mi.options.widgetFullscreen);
            if (mi.options.widgetHome !== null)
                loadedWidgets.Home = this.addWidgetHome(mapView, mi.options.widgetHome);
            if (mi.options.widgetScaleBar !== null)
                loadedWidgets.ScaleBar = this.addWidgetScaleBar(mapView, mi.options.widgetScaleBar);
            if (mi.options.widgetSearch !== null)
                loadedWidgets.Search = this.addWidgetSearch(mapView, mi.options.widgetSearch);
            // Init Sync - Map Lib Implementations - We don't get references for these to put in the InstanceUtils.widgets, 
            // BECAUSE everything else in instanceUtils is meant to allow you to work with these widget's functionality
            // *** It's really interesting seeing these isolated. Makes me feel like we should be trying to 
            // widgitize all these implementations, and not spread out their inner workings across multiple services... 
            // **************** Yes. This is what we should do. It's what we will do. *****************
            if (mi.options.widgetBingMaps !== null)
                this.addWidgetThirdPartyMapButton(mapView, EThirdPartyMapButton.Bing, mi.options.widgetBingMaps, mi.internalState);
            if (mi.options.widgetCommand !== null && mi.options.widgetCommand.length > 0)
                this.addWidgetCommand(mapView, mi.options.widgetCommand);
            if (mi.options.widgetCoordinateOnClick !== null)
                this.addWidgetCoordinateOnClick(mapView, mi.options.widgetCoordinateOnClick, mi.internalState);
            if (mi.options.widgetElevationProfile !== null)
                this.addWidgetElevationProfile(mapView, mi.options.widgetElevationProfile, mi.internalState);
            if (mi.options.widgetGoogleMaps !== null)
                this.addWidgetThirdPartyMapButton(mapView, EThirdPartyMapButton.Google, mi.options.widgetGoogleMaps, mi.internalState);
            ////////////// Initialize Map event listeners //////////////////////////////
            this.mapEventService.setupMapViewEvents(mapView, mi.options, mi.internalState);
            this.mapEventService.eventPopupOnTriggerAction(mapView, mi.internalState);
            //// Initialize SketchViewModels and associated GraphicsLayers
            //// if(mi.options.sketchViewModels !== null && mi.options.sketchViewModels.length > 0){
            ////   this.sketchViewModelService.makeSketchViewModels(mapView, mi.internalState, mi.options.sketchViewModels)
            //// }
            ////////////// Initialize Misc. /////////////////////////////
            if (mi.options.mapEventHoverInfos !== null && mi.options.mapEventHoverInfos.length > 0)
                this.addHoverInfosUI(mapView, mi.options.mapEventHoverInfos, mi.internalState);
            if (mi.options.popupActions !== null && mi.options.popupActions.length > 0)
                this.popupActionService.makePopupActions(mapView, mi.internalState, mi.options.popupActions);
            // wait for all async widgets to load
            yield Promise.all(asyncWidgets);
            // Return Map Instance Utils 
            return this.makeInstanceUtils(mapView, mi.internalState, loadedWidgets);
        });
    }
    makeInstanceUtils(mapView, instanceState, loadedWidgets) {
        return {
            widgets: loadedWidgets,
            sketchViewModel: {
                makeSVM: this.sketchViewModelService.curry_makeSketchViewModel(mapView, instanceState),
                getSVM: this.sketchViewModelService.curry_getSketchViewModel(instanceState),
                getSVMsForGraphicsLayer: this.sketchViewModelService.curry_getSVMsForGraphicsLyr(instanceState),
                destroySVM: this.sketchViewModelService.curry_destroySketchViewModel(instanceState)
            },
            popupActions: {
                popupActionsResults: this.popupActionService.popupActionClickedSubject,
                makePopupAction: this.popupActionService.curry_makePopupAction(mapView, instanceState),
                makePopupActions: this.popupActionService.curry_makePopupActions(mapView, instanceState),
                removePopupAction: this.popupActionService.curry_removePopupAction(mapView, instanceState)
            },
            mapActionButtons: {
                setClickTypeToEsri: this.mapEventService.curry_SetClickTypeToEsri(mapView.map, instanceState),
                widgetCoordinateOnClick_getCoords: instanceState.coords$,
                elevationProfile: {
                    statusInfo: this.elevationProfileService.$elevProfStatus,
                    polylineGraphic: this.elevationProfileService.$elevProfGraphic
                }
            },
            mapEvent: {
                graphicOnHover: instanceState.graphicOnHover
            },
            layerManager: {
                clusterLayer: {
                    makeClusterLayerFromGraphics: this.clusterLayerService.curry_MakeClusterLayerFromGraphics(mapView.map)
                },
                graphicsLayer: {
                    addGraphicsLayers: this.layerManager.curry_addGraphicsLayers(mapView.map)
                }
            }
        };
    }
    asyncLoadWidget(loadedWidgets, loadedWidgetPropName, loadWidgetFunc) {
        return __awaiter(this, void 0, void 0, function* () {
            let widget = yield loadWidgetFunc();
            loadedWidgets[loadedWidgetPropName] = widget;
            return;
        });
    }
    addHoverInfosUI(mapView, hoverInfos, mapState) {
        for (let i = 0; i < hoverInfos.length; i++) {
            mapState.customHoverInfo.hoverInfoProperties.push(hoverInfos[i]);
        }
        let info = this.defineHoverInfoElement();
        mapState.customHoverInfo.hoverInfoElement = info;
        mapView.ui.add(info, 'bottom-left');
    }
    addWidgetAreaMeasurement(mapView, widgetProperties, mapState) {
        return __awaiter(this, void 0, void 0, function* () {
            let areaMeasurement;
            let unit = widgetProperties.defaultUnit != null ? widgetProperties.defaultUnit : 'feet';
            if (this.typeGuardIWidgetPropertiesContainer(widgetProperties.widgetProperties)) {
                // TODO
                console.error("AreaMeasurement Widget not yet implemented to sit in a container.");
                //let props = <WidgetPropertiesContainer>widgetProperties;
                //areaMeasurement.container = document.getElementById(props.container);
                /* let x = document.createElement('button');
                let y = document.createTextNode('Clear');
                x.appendChild(y);
                x.onclick = () => {
                  mapView.ui.remove(areaMeasurement);
                  areaMeasurement.destroy();
                };
                document.getElementById(props.container).appendChild(x); */
                return null;
            }
            else {
                let props = widgetProperties.widgetProperties;
                let expand = yield this.expandService.createExpand({
                    expandIconClass: 'esri-icon-feature-layer',
                    expandTooltip: props.details && props.details.buttonHoverText ? props.details.buttonHoverText : 'Area Measurement',
                    view: mapView,
                    content: null
                }, mapState);
                areaMeasurement = new this.widgetLoadHelper.AreaMeasurement2D({ view: mapView, unit: unit });
                areaMeasurement.container = document.createElement("div");
                expand.content = areaMeasurement;
                expand.watch('expanded', (isExpanded) => {
                    if (isExpanded) {
                        areaMeasurement.viewModel.newMeasurement();
                    }
                    else {
                        areaMeasurement.viewModel.clearMeasurement();
                    }
                });
                this.addToMapUI(mapView, props, expand);
                return areaMeasurement;
            }
        });
    }
    // TODO: custom basemaps; remove basemaps; local|portal source
    addWidgetBasemapGallery(mapView, widgetProperties, mapState) {
        return __awaiter(this, void 0, void 0, function* () {
            let basemapGallery = new this.widgetLoadHelper.BasemapGallery({ view: mapView });
            if (this.typeGuardIWidgetPropertiesContainer(widgetProperties)) {
                let props = widgetProperties;
                basemapGallery.container = document.getElementById(props.container);
                return basemapGallery;
            }
            else {
                let props = widgetProperties;
                basemapGallery.container = document.createElement("div");
                let expand = yield this.expandService.createExpand({
                    expandIconClass: 'esri-icon-basemap',
                    expandTooltip: props.details && props.details.buttonHoverText ? props.details.buttonHoverText : 'Basemap Gallery',
                    view: mapView,
                    content: basemapGallery
                }, mapState);
                this.addToMapUI(mapView, props, expand);
                return basemapGallery;
            }
        });
    }
    addWidgetBasemapToggle(mapView, IWidgetPropertiesBasemapToggle) {
        let basemapToggle = new this.widgetLoadHelper.BasemapToggle({ view: mapView, nextBasemap: IWidgetPropertiesBasemapToggle.nextBasemap });
        let widgetProperties = IWidgetPropertiesBasemapToggle.widgetProperties;
        this.addToMapUI(mapView, widgetProperties, basemapToggle);
        return basemapToggle;
    }
    addWidgetBookmarks(mapView, widgetProperties, mapState) {
        return __awaiter(this, void 0, void 0, function* () {
            let bookmarks = new this.widgetLoadHelper.Bookmarks({ view: mapView });
            if (this.typeGuardIWidgetPropertiesContainer(widgetProperties)) {
                let props = widgetProperties;
                bookmarks.container = document.getElementById(props.container);
                return bookmarks;
            }
            else {
                let props = widgetProperties;
                bookmarks.container = document.createElement("div");
                let expand = yield this.expandService.createExpand({
                    expandIconClass: 'esri-icon-bookmark',
                    expandTooltip: props.details && props.details.buttonHoverText ? props.details.buttonHoverText : 'Bookmarks',
                    view: mapView,
                    content: bookmarks
                }, mapState);
                this.addToMapUI(mapView, widgetProperties, expand);
                return bookmarks;
            }
        });
    }
    addWidgetCommand(mapView, widgetCommands) {
        widgetCommands.forEach((widgetCommand) => {
            // Define Btn
            let commandButton;
            if (widgetCommand.usingEsriIcons) {
                commandButton = this.defineCustomBtn(widgetCommand.btnName, widgetCommand.falseIcon);
            }
            else {
                commandButton = this.defineCustomBtn(widgetCommand.btnName, null, widgetCommand.falseIcon);
            }
            let commandBtnImg = widgetCommand.usingEsriIcons ? commandButton.firstChild : commandButton.firstChild;
            let commandState = false;
            // Handle Click
            commandButton.addEventListener('click', () => {
                commandState = !commandState;
                if (commandState) {
                    if (widgetCommand.usingEsriIcons) {
                        // update esri icon
                        commandBtnImg.classList.remove(widgetCommand.falseIcon);
                        commandBtnImg.classList.add(widgetCommand.trueIcon);
                    }
                    else {
                        commandBtnImg.src = widgetCommand.trueIcon;
                    }
                    this.command$.next([widgetCommand.btnName, commandState]);
                }
                else {
                    if (widgetCommand.usingEsriIcons) {
                        // update esri icon
                        commandBtnImg.classList.remove(widgetCommand.trueIcon);
                        commandBtnImg.classList.add(widgetCommand.falseIcon);
                    }
                    else {
                        commandBtnImg.src = widgetCommand.falseIcon;
                    }
                    this.command$.next([widgetCommand.btnName, commandState]);
                }
            });
            this.addToMapUI(mapView, widgetCommand.widgetProperties, commandButton);
        });
    }
    addWidgetCoordinateConversion(mapView, widgetProperties, mapState) {
        return __awaiter(this, void 0, void 0, function* () {
            let coordinateConversion = new this.widgetLoadHelper.CoordinateConversion({ view: mapView });
            if (this.typeGuardIWidgetPropertiesContainer(widgetProperties)) {
                let props = widgetProperties;
                coordinateConversion.container = document.getElementById(props.container);
                return coordinateConversion;
            }
            else {
                let props = widgetProperties;
                coordinateConversion.container = document.createElement("div");
                let expand = yield this.expandService.createExpand({
                    expandIconClass: 'esri-icon-map-pin',
                    expandTooltip: props.details && props.details.buttonHoverText ? props.details.buttonHoverText : 'Coordinate Conversion',
                    view: mapView,
                    content: coordinateConversion
                }, mapState);
                this.addToMapUI(mapView, widgetProperties, expand);
                return coordinateConversion;
            }
        });
    }
    addWidgetCoordinateOnClick(mapView, widgetProperties, mapState) {
        // Init Btn UI
        let uiButton = this.defineCustomBtn(widgetProperties.details && widgetProperties.details.buttonHoverText ? widgetProperties.details.buttonHoverText : 'Get Coordinate', 'esri-icon-blank-map-pin');
        mapState.actionButtonWidgets.push([uiButton, EActiveClickType.coords, () => { }]);
        // Click Behavior
        uiButton.addEventListener('click', () => {
            if (mapState.ActiveClickType !== EActiveClickType.coords) {
                this.mapEventService.setActiveClickType(mapView.map, EActiveClickType.coords, mapState);
            }
            else {
                this.mapEventService.setClickTypeToEsri(mapView.map, mapState);
            }
        });
        this.addToMapUI(mapView, widgetProperties, uiButton);
    }
    addWidgetDistanceMeasurement(mapView, widgetProperties, mapState) {
        return __awaiter(this, void 0, void 0, function* () {
            let distanceMeasurement; // = new DistanceMeasurement2D({ view: mapView });
            let unit = widgetProperties.defaultUnit != null ? widgetProperties.defaultUnit : 'feet';
            if (this.typeGuardIWidgetPropertiesContainer(widgetProperties.widgetProperties)) {
                let props = widgetProperties.widgetProperties;
                distanceMeasurement = new this.widgetLoadHelper.DistanceMeasurement2D({ view: mapView, unit: unit });
                distanceMeasurement.container = document.getElementById(props.container);
                return distanceMeasurement;
            }
            else {
                let props = widgetProperties.widgetProperties;
                let expand = yield this.expandService.createExpand({
                    expandIconClass: 'esri-icon-polyline',
                    expandTooltip: props.details && props.details.buttonHoverText ? props.details.buttonHoverText : 'Distance Measurement',
                    view: mapView,
                    content: null
                }, mapState);
                distanceMeasurement = new this.widgetLoadHelper.DistanceMeasurement2D({ view: mapView, unit: unit });
                distanceMeasurement.container = document.createElement("div");
                expand.content = distanceMeasurement;
                expand.watch("expanded", (isExpanded) => {
                    if (isExpanded) {
                        distanceMeasurement.viewModel.newMeasurement();
                    }
                    else {
                        distanceMeasurement.viewModel.clearMeasurement();
                    }
                });
                this.addToMapUI(mapView, widgetProperties.widgetProperties, expand);
                return distanceMeasurement;
            }
        });
    }
    addWidgetFullscreen(mapView, widgetProperties) {
        let fullscreen = new this.widgetLoadHelper.Fullscreen({ view: mapView });
        this.addToMapUI(mapView, widgetProperties, fullscreen);
        return fullscreen;
    }
    addWidgetHome(mapView, widgetProperties) {
        let home = new this.widgetLoadHelper.Home({ view: mapView });
        this.addToMapUI(mapView, widgetProperties, home);
        return home;
    }
    // TODO: add a legend to the layerlist option (https://developers.arcgis.com/javascript/latest/sample-code/widgets-layerlist-legend/index.html)
    addWidgetLayerList(mapView, widgetProperties, mapState) {
        return __awaiter(this, void 0, void 0, function* () {
            let layerList = new this.widgetLoadHelper.LayerList({ view: mapView });
            if (this.typeGuardIWidgetPropertiesContainer(widgetProperties)) {
                let props = widgetProperties;
                layerList.container = document.getElementById(props.container);
                return layerList;
            }
            else {
                let props = widgetProperties;
                layerList.container = document.createElement("div");
                let expand = yield this.expandService.createExpand({
                    expandIconClass: 'esri-icon-layers',
                    expandTooltip: props.details && props.details.buttonHoverText ? props.details.buttonHoverText : 'Layer List',
                    view: mapView,
                    content: layerList
                }, mapState);
                this.addToMapUI(mapView, widgetProperties, expand);
                return layerList;
            }
        });
    }
    addWidgetLegend(mapView, widgetProperties, mapState) {
        return __awaiter(this, void 0, void 0, function* () {
            let legend = new this.widgetLoadHelper.Legend({ view: mapView });
            if (this.typeGuardIWidgetPropertiesContainer(widgetProperties)) {
                let props = widgetProperties;
                legend.container = document.getElementById(props.container);
                return legend;
            }
            else {
                let props = widgetProperties;
                legend.container = document.createElement("div");
                let expand = yield this.expandService.createExpand({
                    expandIconClass: 'esri-icon-layer-list',
                    expandTooltip: props.details && props.details.buttonHoverText ? props.details.buttonHoverText : 'Legend',
                    view: mapView,
                    content: legend
                }, mapState);
                this.addToMapUI(mapView, widgetProperties, expand);
                return legend;
            }
        });
    }
    addWidgetPrint(mapView, IWidgetPropertiesPrint, mapState) {
        return __awaiter(this, void 0, void 0, function* () {
            let print = new this.widgetLoadHelper.Print({ view: mapView, printServiceUrl: IWidgetPropertiesPrint.printServiceUrl });
            if (this.typeGuardIWidgetPropertiesContainer(IWidgetPropertiesPrint.widgetProperties)) {
                let props = IWidgetPropertiesPrint.widgetProperties;
                print.container = document.getElementById(props.container);
                return print;
            }
            else {
                let props = IWidgetPropertiesPrint.widgetProperties;
                print.container = document.createElement("div");
                let expand = yield this.expandService.createExpand({
                    expandIconClass: 'esri-icon-printer',
                    expandTooltip: props.details && props.details.buttonHoverText ? props.details.buttonHoverText : 'Print',
                    view: mapView,
                    content: print
                }, mapState);
                this.addToMapUI(mapView, IWidgetPropertiesPrint.widgetProperties, expand);
                return print;
            }
        });
    }
    addWidgetScaleBar(mapView, widgetProperties) {
        let scaleBar = new this.widgetLoadHelper.ScaleBar({ view: mapView });
        this.addToMapUI(mapView, widgetProperties, scaleBar);
        return scaleBar;
    }
    addWidgetSearch(mapView, IWidgetPropertiesSearch) {
        let widgetProperties = IWidgetPropertiesSearch.widgetProperties;
        let search = new this.widgetLoadHelper.Search({ view: mapView });
        if (IWidgetPropertiesSearch.sources !== undefined) {
            if (IWidgetPropertiesSearch.sources.length > 0) {
                search.sources = IWidgetPropertiesSearch.sources;
            }
        }
        this.addToMapUI(mapView, widgetProperties, search);
        return search;
    }
    addWidgetThirdPartyMapButton(mapView, mapType, widgetPropsTPMButton, mapState) {
        // Init Btn UI
        let uiButton;
        let clickType;
        if (mapType === EThirdPartyMapButton.Bing) {
            uiButton = this.defineCustomBtn('Bing Maps', 'esri-icon-maps');
            mapState.actionButtonWidgets.push([uiButton, EActiveClickType.bingMaps, () => { }]);
            clickType = EActiveClickType.bingMaps;
        }
        else if (mapType === EThirdPartyMapButton.Google) {
            uiButton = this.defineCustomBtn('Google Maps', 'esri-icon-globe');
            mapState.actionButtonWidgets.push([uiButton, EActiveClickType.googleMaps, () => { }]);
            clickType = EActiveClickType.googleMaps;
        }
        // Click Behavior
        uiButton.addEventListener('click', () => {
            if (mapState.ActiveClickType !== clickType) {
                this.mapEventService.setActiveClickType(mapView.map, clickType, mapState);
            }
            else {
                this.mapEventService.setClickTypeToEsri(mapView.map, mapState);
            }
        });
        this.addToMapUI(mapView, widgetPropsTPMButton.widgetProperties, uiButton);
    }
    addWidgetElevationProfile(mapView, widgetProperties, mapState) {
        // Init Btn UI
        let uiButton = this.defineCustomBtn('Elevation Profile', 'esri-icon-line-chart');
        let clickType = EActiveClickType.elevationProfile;
        mapState.actionButtonWidgets.push([
            uiButton,
            clickType,
            this.elevationProfileService.endSketch.bind(this.elevationProfileService, mapView, mapState, true)
        ]);
        // Click Behavior
        uiButton.addEventListener('click', () => {
            if (mapState.ActiveClickType !== clickType) {
                this.mapEventService.setActiveClickType(mapView.map, clickType, mapState);
                this.elevationProfileService.startSketch(mapView, mapState);
            }
            else {
                // this.mapEventService.setClickTypeToEsri(mapView.map, mapState); // don't need this here - endSketch method does this
                this.elevationProfileService.endSketch(mapView, mapState);
            }
        });
        this.addToMapUI(mapView, widgetProperties, uiButton);
    }
    typeGuardIWidgetPropertiesContainer(item) {
        return item.container !== undefined;
    }
    /** Positions UI Element on the Map based on where it is specified to go in it's IWidgetPropertiesMap. */
    addToMapUI(mapView, mapWidgetProps, uiElementToAdd) {
        if (mapWidgetProps.index !== undefined) {
            mapView.ui.add(uiElementToAdd, { position: mapWidgetProps.position, index: mapWidgetProps.index });
        }
        else {
            mapView.ui.add(uiElementToAdd, mapWidgetProps.position);
        }
    }
    // TODO: Attention
    // 
    // let sketchPolylineSymbolElevationProfile: any;
    // let sketchViewModelElevationProfile: __esri.SketchViewModel;
    // Elev Prof
    // if (useElevationProfile) {
    //   mapProps.customElevationProfile = this.defineCustomBtn('Elevation Profile', 'esri-icon-line-chart');
    //   sketchPolylineSymbolElevationProfile = mapConfig.instanceSymbology.symSketchPolyline;
    //   sketchViewModelElevationProfile = new SketchViewModel({
    //     view: mapView,
    //     polylineSymbol: sketchPolylineSymbolElevationProfile
    //   });
    //   this.eventElevationProfileClick(mapProps, map, sketchViewModelElevationProfile);
    //   let urlElevationProfile = mapConfig.urlServiceElevationProfile;
    //   this.utilGeoprocessorElevationProfile = new Geoprocessor({ url: urlElevationProfile });
    // }
    // Todo: Sketch Select
    // if (useSketchSelect) {
    //   mapProps.customSketchSelect = this.defineCustomBtn('Select Features', 'esri-icon-polygon');
    //   sketchPolygonSymbol = mapConfig.instanceSymbology.symSketchPolygon;// this.symSketchPolygon();
    //   sketchViewModelSelectFeatures = new SketchViewModel({
    //     view: mapView,
    //     //layer: sketchGL,
    //     polygonSymbol: sketchPolygonSymbol
    //   });
    //   this.eventSketchSelectClick(mapProps, map, sketchViewModelSelectFeatures);
    // }
    // let gls: any[] = [];
    // GRAPHICS LAYERS
    //TODO: !Attention
    // REFACTOR NOTE: Should I allow dymanic creation of Graphics Layers straight up? Probably yea...  
    // if (useDraw) {
    //   let glDraw = new GraphicsLayer({ id: 'draw', title: 'Draw', listMode: 'hide' });
    //   gls.push(glDraw);
    // }``
    // let glHighlight = new GraphicsLayer({ id: 'highlight', title: 'Highlight', listMode: 'hide' });
    // gls.push(glHighlight);
    // let glSelect = new GraphicsLayer({ id: 'select', title: 'Select', listMode: 'hide' });
    // gls.push(glSelect);
    // if (useElevationProfile) {
    //   let glElevationProfile = new GraphicsLayer({ id: 'elevationProfile', title: 'Elevation Profile', listMode: 'hide' });
    //   gls.push(glElevationProfile);
    // }
    // if (useMeasure) {
    //   let glMeasure = new GraphicsLayer({ id: 'measure', title: 'Measure', listMode: 'hide' });
    //   gls.push(glMeasure);
    // }
    // if (useSketchSelect) {
    //   let glSketch = new GraphicsLayer({ id: 'sketch', title: 'Sketch', listMode: 'hide' });
    //   gls.push(glSketch);
    // }
    // map.addMany(gls);
    // hide (listMode) graphics layers from the layer list
    // let mapLayers: any = map.layers;
    // mapLayers.items.forEach(item => {
    //   if (item.type === 'graphics') {
    //     if (item.listMode === 'show') item.listMode = 'hide';
    //   }
    // });
    // TODO: Attention
    // watchUtils.when(mapView, 'stationary', () => {
    //   if (mapProps.allowViewWatch) {
    //     if (useViewExtent) {
    //       if (mapProps.extentIndex < (mapProps.viewExtents.length - 1)) {
    //         while (mapProps.extentIndex < (mapProps.viewExtents.length - 1)) {
    //           mapProps.viewExtents.pop();
    //         }
    //       }
    //       mapProps.viewExtents.push({ center: mapView.center, zoom: mapView.zoom });
    //       mapProps.extentIndex = mapProps.viewExtents.length - 1;
    //     }
    //   }
    //   mapProps.allowViewWatch = true;
    // });
    // TODO: Attention
    // watchUtils.whenTrue(mapView, 'stationary', () => {
    //   if (mapConfig.watchStationary === true) {
    //     if (mapView.center) {
    //       this.stationary$.next({ center: mapView.center, zoom: mapView.zoom });
    //     }
    //   }
    // });
    defineCustomBtn(title, icon, imgUrl) {
        let custom;
        let btn;
        function _createButton() {
            custom = document.createElement('div');
            custom.classList.add('esri-widget');
            custom.classList.add('esri-widget--button');
            custom.title = title;
        }
        function _createEsriIcon() {
            btn = document.createElement('span');
            btn.classList.add(icon);
        }
        function _createImgIcon() {
            btn = document.createElement('img');
            btn.src = imgUrl;
            btn.width = 16;
        }
        _createButton();
        if (imgUrl) {
            _createImgIcon();
        }
        else {
            _createEsriIcon();
        }
        custom.appendChild(btn);
        return custom;
    }
    defineHoverInfoElement() {
        let info = document.createElement('div');
        info.style.backgroundColor = '#000000';
        info.style.opacity = '0.75';
        info.style.padding = '5px';
        info.style.fontFamily = 'arial';
        info.style.fontSize = 'x-small';
        info.style.fontWeight = 'bold';
        info.style.color = 'white';
        info.innerHTML = '';
        info.style.visibility = 'hidden';
        return info;
    }
    // TODO: temp graphics layers for sketch 'cause layer property not working on sketchViewModel
    // eventSketchSelectClick(mapProps: MapProps, map: any, sketchViewModel: __esri.SketchViewModel) {
    //   mapProps.customSketchSelect.addEventListener('click', () => {
    //     this.actionResetButtons(mapProps);
    //     if (mapProps.activeClick !== ActiveClickType.featureDrawSelect) {
    //       mapProps.activeClick = ActiveClickType.featureDrawSelect;
    //       mapProps.customSketchSelect.style.backgroundColor = "#f6c51b";
    //       this.actionPopupState(map, true);
    //       sketchViewModel.create('polygon');
    //     } else {
    //       mapProps.activeClick = ActiveClickType.esri;
    //       this.actionPopupState(map, false);
    //       sketchViewModel.reset();
    //       let gl = map.findLayerById('sketch');
    //       if (gl) {
    //         gl.removeAll();
    //       }
    //     }
    //   });
    // }
    getGraphicInstance() {
        return new this.instGraphic();
    }
    getPolygonInstance(props) {
        return new this.instPolygon(props);
    }
    // idk what this does...
    symPolygonHidden() {
        return { type: 'simple-fill', color: 'rgba(0,0,0,0)', style: 'none', outline: { color: 'rgba(0,0,0,0)', width: '0px', style: 'none' } };
    }
};
MapService.ɵfac = function MapService_Factory(t) { return new (t || MapService)(ɵngcc0.ɵɵinject(ClusterLayerService), ɵngcc0.ɵɵinject(GeometryService), ɵngcc0.ɵɵinject(ExpandableWidgetControllerService), ɵngcc0.ɵɵinject(LayerManagerService), ɵngcc0.ɵɵinject(SketchViewModelMakerService), ɵngcc0.ɵɵinject(ActionMapEventControllerService), ɵngcc0.ɵɵinject(PopupActionControllerService), ɵngcc0.ɵɵinject(ElevationProfileService), ɵngcc0.ɵɵinject(LoadWidgetsHelperService)); };
MapService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: MapService, factory: function (t) { return MapService.ɵfac(t); }, providedIn: "root" });
MapService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MapService_Factory() { return new MapService(ɵɵinject(ClusterLayerService), ɵɵinject(GeometryService), ɵɵinject(ExpandableWidgetControllerService), ɵɵinject(LayerManagerService), ɵɵinject(SketchViewModelMakerService), ɵɵinject(ActionMapEventControllerService), ɵɵinject(PopupActionControllerService), ɵɵinject(ElevationProfileService), ɵɵinject(LoadWidgetsHelperService)); }, token: MapService, providedIn: "root" });
MapService = __decorate([ __metadata("design:paramtypes", [ClusterLayerService,
        GeometryService,
        ExpandableWidgetControllerService,
        LayerManagerService,
        SketchViewModelMakerService,
        ActionMapEventControllerService,
        PopupActionControllerService,
        ElevationProfileService,
        LoadWidgetsHelperService])
], MapService);

let DynamicEsriLoaderService = class DynamicEsriLoaderService {
    constructor() { }
    dynamicModuleLoad(esriModuleNames) {
        return new Promise((res, rej) => {
            esriLoader.loadModules(esriModuleNames).then((esriModuleNames) => {
                res(esriModuleNames);
            }).catch((err => {
                rej(err);
            }));
        });
    }
};
DynamicEsriLoaderService.ɵfac = function DynamicEsriLoaderService_Factory(t) { return new (t || DynamicEsriLoaderService)(); };
DynamicEsriLoaderService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DynamicEsriLoaderService, factory: function (t) { return DynamicEsriLoaderService.ɵfac(t); }, providedIn: 'root' });
DynamicEsriLoaderService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DynamicEsriLoaderService_Factory() { return new DynamicEsriLoaderService(); }, token: DynamicEsriLoaderService, providedIn: "root" });
DynamicEsriLoaderService = __decorate([ __metadata("design:paramtypes", [])
], DynamicEsriLoaderService);

let AuthService = class AuthService {
    constructor() {
        // Called here because the IdentityManager clears out the Hash String in the url - so we need to get to it before that happens
        this.setLastLoadPortalFail();
    }
    setLastLoadPortalFail() {
        // If loadPortal function fails, it passes back msg in hash string. Can use that to find out if load failed
        if (window.location.hash.indexOf("access_denied") !== -1) {
            this.lastAuth = true;
        }
        else {
            this.lastAuth = false;
        }
    }
    didLastPortalLoadFail() {
        return this.lastAuth;
    }
    // async loadScript(version: string, opts: any) {
    //   let options: ILoadScriptOptions = {
    //     url: '//js.arcgis.com/' + version
    //   };
    //   if (opts.dojoConfig) options.dojoConfig = opts.dojoConfig;
    //   return await esriLoader.loadScript(options);
    // };
    setPortal(portalUrl, proxyRules) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield esriLoader
                .loadModules([
                "esri/config",
                "esri/identity/IdentityManager",
                "esri/core/urlUtils",
            ])
                .then(([esriConfig, esriId, urlUtils]) => {
                this.srvcEsriConfig = esriConfig;
                this.srvcEsriConfig.portalUrl = portalUrl;
                this.srvcEsriConfig.request.trustedServers.push(portalUrl);
                this.srvcEsriId = esriId;
                if (proxyRules) {
                    proxyRules.forEach((proxyRule) => {
                        urlUtils.addProxyRule(proxyRule);
                    });
                }
            })
                .catch((err) => {
                console.error(err);
            });
        });
    }
    /**
     * Sign into Portal.
     *
     * Parameter References:
     * portalUrl, appId, popup: https://developers.arcgis.com/javascript/latest/api-reference/esri-identity-OAuthInfo.html#properties-summary
     * authMode https://developers.arcgis.com/javascript/latest/api-reference/esri-portal-Portal.html#authMode
     */
    loadPortal(portalUrl, appId, authMode, popup) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield esriLoader
                .loadModules(["esri/identity/OAuthInfo", "esri/portal/Portal"])
                .then(([OAuthInfo, Portal]) => __awaiter(this, void 0, void 0, function* () {
                let info = new OAuthInfo({
                    appId: appId,
                    portalUrl: portalUrl,
                    popup: popup,
                });
                this.srvcEsriId.registerOAuthInfos([info]);
                let portal = new Portal({
                    authMode: authMode,
                });
                return yield portal.load();
            }))
                .catch((err) => {
                console.error(err);
            });
        });
    }
    //registerToken(props: __esri.IdentityManagerBaseRegisterTokenProperties) {
    registerToken(props) {
        this.srvcEsriId.registerToken(props);
    }
    checkSignInStatus(portalUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.srvcEsriId.checkSignInStatus(portalUrl + "/sharing/rest");
        });
    }
    signOutPortal() {
        this.srvcEsriId.destroyCredentials();
        window.location.reload();
    }
};
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(); };
AuthService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthService, factory: function (t) { return AuthService.ɵfac(t); }, providedIn: "root" });
AuthService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(); }, token: AuthService, providedIn: "root" });
AuthService = __decorate([ __metadata("design:paramtypes", [])
], AuthService);

let MapComponent = class MapComponent {
    constructor(
    // public Services
    _mapService, esriLoader, authService, 
    // private Services
    mapEventService) {
        this._mapService = _mapService;
        this.esriLoader = esriLoader;
        this.authService = authService;
        this.mapEventService = mapEventService;
        // First Step of Loading - TODO: add why you would use this trigger
        this.isInitialAPILoaded = new BehaviorSubject(false);
        // Second Steps of Loading - TODO: add why you would use this trigger
        this.mapViewLoaded = new BehaviorSubject(false);
        this.mapViewLoadFailed = new BehaviorSubject(false);
        // Third Step of Loading - TODO: add why you would use this trigger
        /** Use to find out if the Instance of the Map is fully Loaded (Meaning all Map Widgets and Map Related Functionality is fully loaded) */
        this.isInstanceFullyLoaded = new BehaviorSubject(false);
        this.mapMessage = new EventEmitter();
        this.popupAction = new EventEmitter();
        this.mapActionExtents = new EventEmitter();
        // Do initial ArcGIS API load
        _mapService.loadScript().then(() => {
            this.isInitialAPILoaded.next(true);
        });
        _mapService.extents$.subscribe((data) => {
            if (data.length > 0) {
                this.mapActionExtents.emit(data[0]);
            }
            else
                this.mapMessage.emit("Error getting map extents");
        });
        // Todo - implement when map is stationary - have to put in instance state
        // _mapService.stationary$.subscribe((data: any) => {
        //   if (data.center) this.mapActionStationary.emit(data);
        //   else this.mapMessage.emit('Error getting map center');
        // });
    }
    ngOnInit() { }
    loadMap2(mapId, mapConfig) {
        this.mapConfig2 = mapConfig;
        // this.mapId = mapId;
        // this.el.nativeElement.id = mapId;
        // console.log(mapId);
        this.isInitialAPILoaded.subscribe((isLoaded) => {
            if (isLoaded) {
                this._mapService
                    .createMapView(mapConfig.mapType, mapConfig.mapProperties, mapConfig.webMapProperties, mapConfig.mapViewProperties, this.el.nativeElement)
                    .then((mapView) => {
                    // console.log('mapView', mapView);
                    this.mapView = mapView;
                    mapView.when(() => {
                        // console.log('map view loaded');
                        this._mapService
                            .configMapInstance(mapConfig.mapInstance, mapView)
                            .then((instanceUtils) => {
                            this.instanceUtils = instanceUtils;
                            this.isInstanceFullyLoaded.next(true);
                        });
                        this.mapViewLoaded.next(true);
                    }, () => {
                        console.error("AMT Error ::: MapView Failed to Load. Please check your MapConfig");
                        this.mapViewLoadFailed.next(true);
                    });
                });
            }
        });
    }
    // TODO: move to select Features Service ---------------------------------------------------------
    // if (this.sketchViewModelSelectFeatures !== undefined) {
    //   let sketchPolygonSymbol: any = this.mapConfig.instanceSymbology.symSketchPolygon;// this._mapService.symSketchPolygon();
    //   this.sketchViewModelSelectFeatures.on('create-complete', (evt) => {
    //     let gl: any = this.mapView.map.findLayerById('sketch');
    //     gl.removeAll();
    //     let geometry = evt.geometry;
    //     let symbol;
    //     switch (geometry.type) {
    //       default: symbol = sketchPolygonSymbol; break;
    //     }
    //     gl.add({ geometry: geometry, symbol: symbol });
    //     let q: QueryProperties = new QueryProperties(this.mapConfig.instanceProperties.sketchSelectLayerType, this.mapConfig.instanceProperties.sketchSelectLayerId);
    //     q.geometry = evt.geometry;
    //     if (this.mapConfig.instanceProperties.sketchSelectLayerType === LayerType.MapImageLayer) q.sublayerId = this.mapConfig.instanceProperties.sketchSelectSublayerId;
    //     this.queryLayer(q).then((results) => {
    //       this.sketchActionSelectFeatures.emit(results);
    //       this.sketchViewModelSelectFeatures.create('polygon');
    //     }, (err) => {
    //       this.mapMessage.emit('select features: ' + err.message);
    //     });
    //   });
    // }
    // callable functions (on an instance of the map!)
    addCustomGraphic(graphicsLayerId, geometry, symbol, popupTemplate, clearGraphicsLayer) {
        let gl = this.mapView.map.findLayerById(graphicsLayerId);
        if (gl !== undefined) {
            let gl2 = gl;
            if (clearGraphicsLayer && clearGraphicsLayer === true)
                gl2.removeAll();
            let g = this._mapService.getGraphicInstance();
            g.geometry = geometry;
            g.symbol = symbol;
            if (popupTemplate && popupTemplate !== null)
                g.popupTemplate = popupTemplate;
            gl2.add(g);
            return g;
        }
        else {
            this.mapMessage.emit("Could not find graphics layer (" + graphicsLayerId + ") in the map");
        }
    }
    addCustomGraphics(graphicsLayerId, graphics, clearGraphicsLayer) {
        let gl = this.mapView.map.findLayerById(graphicsLayerId);
        if (gl !== undefined) {
            let gl2 = gl;
            if (clearGraphicsLayer && clearGraphicsLayer === true)
                gl2.removeAll();
            gl2.addMany(graphics);
        }
        else {
            this.mapMessage.emit("Could not find graphics layer (" + graphicsLayerId + ") in the map");
        }
    }
    removeCustomGraphic(graphicsLayerId, graphic) {
        let gl = this.mapView.map.findLayerById(graphicsLayerId);
        if (gl !== undefined) {
            let gl2 = gl;
            gl2.remove(graphic);
        }
        else {
            this.mapMessage.emit("Could not find graphics layer (" + graphicsLayerId + ") in the map");
        }
    }
    clearCustomGraphics(graphicsLayerIds) {
        for (let i = 0; i < graphicsLayerIds.length; i++) {
            let gl = this.mapView.map.findLayerById(graphicsLayerIds[i]);
            if (gl !== undefined)
                gl.removeAll();
        }
    }
    customGraphicsZoomPointLatLon(graphicsLayerId, pts, sym, popupTemplate) {
        let gl = this.mapView.map.findLayerById(graphicsLayerId);
        if (gl !== undefined) {
            gl.removeAll();
            let numPts = pts.length;
            // define the extent based on the input points
            if (numPts > 1) {
                let rings = [];
                let left = pts[0].longitude;
                let right = pts[0].longitude;
                let bottom = pts[0].latitude;
                let top = pts[0].latitude;
                for (let i = 1; i < pts.length; i++) {
                    if (pts[i].longitude < left)
                        left = pts[i].longitude;
                    if (pts[i].longitude > right)
                        right = pts[i].longitude;
                    if (pts[i].latitude < bottom)
                        bottom = pts[i].latitude;
                    if (pts[i].latitude > top)
                        top = pts[i].latitude;
                }
                let bl = [left, bottom];
                let tl = [left, top];
                let tr = [right, top];
                let br = [right, bottom];
                rings.push(bl);
                rings.push(tl);
                rings.push(tr);
                rings.push(br);
                rings.push(bl);
                let poly = {
                    type: "polygon",
                    rings: rings,
                    spatialReference: { wkid: 4326 },
                };
                let extent = {
                    geometry: poly,
                    symbol: this._mapService.symPolygonHidden(),
                };
                gl.add(extent);
            }
            // loop the points and add as graphics
            let graphics = [];
            for (let i = 0; i < pts.length; i++) {
                let pt = {
                    type: "point",
                    longitude: pts[i].longitude,
                    latitude: pts[i].latitude,
                };
                let g = { geometry: pt, symbol: sym };
                if (popupTemplate !== null) {
                    g.attributes = pts[i];
                    g.popupTemplate = popupTemplate;
                }
                graphics.push(g);
            }
            gl.addMany(graphics);
            if (numPts === 1) {
                this.mapView.goTo({
                    center: [pts[0].longitude, pts[0].latitude],
                    zoom: 18,
                });
            }
            else {
                // use the extent graphic to zoom to the bounds - then zoom out one level
                this.mapView
                    .goTo({ target: gl.graphics.items[0].geometry })
                    .then(() => {
                    this.mapView.zoom = this.mapView.zoom - 1;
                });
            }
        }
        else {
            this.mapMessage.emit("customGraphicsZoomPointLatLon: could not find graphics layer");
        }
    }
    highlightFeature(geometry, symbol) {
        let gl = this.mapView.map.findLayerById("highlight");
        gl.removeAll();
        // let symbol; // TODO: Find a good place in mapConfig to define symbology to use... maybe make a Constructor type thing that walks you through making a symbology
        // switch(geometry.type) {
        //   case 'polyline': symbol = this.mapConfig.instanceSymbology.symHighlightPolyline; break;
        //   case 'polygon': symbol = this.mapConfig.instanceSymbology.symHighlightPolygon; break;
        //   default: symbol = this.mapConfig.instanceSymbology.symHighlightPoint; break;
        // }
        gl.add({ geometry: geometry, symbol: symbol });
    }
    setActiveClick(activeClickType, disablePopup) {
        this.mapEventService.setActiveClickType(this.mapView.map, activeClickType, this.mapConfig2.mapInstance.internalState);
        this.mapEventService.actionPopupState(this.mapView.map, disablePopup);
    }
    startSnapping() {
        console.log("IN Start Snapping");
        this.mapEventService.setActiveClickType(this.mapView.map, EActiveClickType.snapping, this.mapConfig2.mapInstance.internalState);
    }
    refreshLayer(layerId, layerType) {
        let lyr = this.mapView.map.findLayerById(layerId);
        switch (layerType) {
            case ELayerType.FeatureLayer:
                let lyr1 = lyr;
                lyr1.refresh();
                break;
            case ELayerType.MapImageLayer:
                let lyr2 = lyr;
                lyr2.refresh();
                break;
        }
    }
    // callable asynchronous functions
    project(urlGeometryService, geometries, outSpatialReference) {
        return __awaiter(this, void 0, void 0, function* () {
            var outSR = new this._mapService.instSpatialReference({
                wkid: outSpatialReference,
            });
            let gs = new this._mapService.taskGeometryService({
                url: urlGeometryService,
            });
            let pp = new this._mapService.taskProjectParameters({
                geometries: geometries,
                outSpatialReference: outSR,
            });
            return yield gs.project(pp);
        });
    }
    queryLayer(queryProps) {
        return __awaiter(this, void 0, void 0, function* () {
            let q = {
                outFields: queryProps.outFields,
                outSpatialReference: { wkid: queryProps.outSpatialReferenceWKID },
                returnGeometry: queryProps.returnGeometry,
            };
            if (queryProps.where !== null)
                q.where = queryProps.where;
            if (queryProps.geometry !== null) {
                q.geometry = queryProps.geometry;
                q.spatialRelationship =
                    queryProps.spatialRelationship &&
                        queryProps.spatialRelationship !== null
                        ? queryProps.spatialRelationship
                        : "intersects";
            }
            if (queryProps.text !== null)
                q.text = queryProps.text;
            if (queryProps.where === null &&
                queryProps.geometry === null &&
                queryProps.text === null)
                return null;
            let l = this.mapView.map.findLayerById(queryProps.layerId);
            if (l) {
                if (queryProps.layerType === ELayerType.MapImageLayer) {
                    let mil = l;
                    let sl = mil.findSublayerById(queryProps.sublayerId);
                    if (sl) {
                        if (sl.definitionExpression != null) {
                            q.where += ` AND (${sl.definitionExpression})`; // def expression is set in either the webmap or directly in the service
                        }
                        return yield sl.queryFeatures(q);
                    }
                    else
                        return null;
                }
                else {
                    let fl = l;
                    if (fl.definitionExpression != null) {
                        q.where += ` AND (${fl.definitionExpression})`;
                    }
                    return yield fl.queryFeatures(q);
                }
            }
            else
                return null;
        });
    }
    queryLayerForObjectIds(queryProps) {
        return __awaiter(this, void 0, void 0, function* () {
            let q = {};
            if (queryProps.where !== null)
                q.where = queryProps.where;
            if (queryProps.geometry !== null) {
                q.geometry = queryProps.geometry;
                q.spatialRelationship =
                    queryProps.spatialRelationship &&
                        queryProps.spatialRelationship !== null
                        ? queryProps.spatialRelationship
                        : "intersects";
            }
            if (queryProps.text !== null)
                q.text = queryProps.text;
            if (queryProps.where === null &&
                queryProps.geometry === null &&
                queryProps.text === null)
                return [-1];
            let l = this.mapView.map.findLayerById(queryProps.layerId);
            if (l) {
                if (queryProps.layerType === ELayerType.MapImageLayer) {
                    let mil = l;
                    let sl = mil.findSublayerById(queryProps.sublayerId);
                    if (sl) {
                        // TODO: Sublayer does not yet have a queryObjectIds method in the API
                        return [0];
                    }
                    else
                        return [-1];
                }
                else {
                    let fl = l;
                    return yield fl.queryObjectIds(q);
                }
            }
            else
                return [-1];
        });
    }
    queryLayerForRelatedFeatures(q, relationshipQuery) {
        return __awaiter(this, void 0, void 0, function* () {
            let l = this.mapView.map.findLayerById(q.layerId);
            if (l) {
                if (q.layerType === ELayerType.MapImageLayer) {
                    let mil = l;
                    let sl = mil.findSublayerById(q.sublayerId);
                    if (sl) {
                        //let sl2Fl: IPromise<__esri.FeatureLayer> = sl.createFeatureLayer();
                        let sl2Fl = yield sl.createFeatureLayer();
                        return sl2Fl.queryRelatedFeatures(relationshipQuery);
                        //return await sl2Fl.queryRelatedFeatures(relationshipQuery);
                    }
                    else
                        return null;
                }
                else {
                    let fl = l;
                    return yield fl.queryRelatedFeatures(relationshipQuery);
                }
            }
            else
                return null;
        });
    }
    queryTaskFeatures(url, q) {
        return __awaiter(this, void 0, void 0, function* () {
            let qt = new this._mapService.taskQueryTask({ url: url });
            return yield qt.execute(q);
        });
    }
    queryTaskFeatureCount(url, q) {
        return __awaiter(this, void 0, void 0, function* () {
            let qt = new this._mapService.taskQueryTask({ url: url });
            return yield qt.executeForCount(q);
        });
    }
    queryTaskObjectIds(url, q) {
        return __awaiter(this, void 0, void 0, function* () {
            let qt = new this._mapService.taskQueryTask({ url: url });
            return yield qt.executeForIds(q);
        });
    }
    queryTaskRelationship(url, relationshipQuery) {
        return __awaiter(this, void 0, void 0, function* () {
            let qt = new this._mapService.taskQueryTask({ url: url });
            return yield qt.executeRelationshipQuery(relationshipQuery);
        });
    }
    esriRequest(url, query) {
        return __awaiter(this, void 0, void 0, function* () {
            let opts = {};
            if (query && query !== null)
                opts = query;
            return yield this._mapService.esriRequest(url, opts);
        });
    }
    zoomToFeature(geometry, zoom) {
        return __awaiter(this, void 0, void 0, function* () {
            if (geometry.type === "point")
                return yield this.mapView.goTo({ target: geometry, zoom: zoom });
            else {
                return yield this.mapView.goTo(geometry).then(() => {
                    this.mapView.zoom = this.mapView.zoom - 1;
                });
            }
        });
    }
    zoomToLatLon(lat, lon, zoom) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.mapView.goTo({ center: [lon, lat], zoom: zoom });
        });
    }
    zoomToPtsExtent(pts) {
        return __awaiter(this, void 0, void 0, function* () {
            let numPts = pts.length;
            // define the extent based on the input points
            if (numPts > 1) {
                let rings = [];
                let left = pts[0].longitude;
                let right = pts[0].longitude;
                let bottom = pts[0].latitude;
                let top = pts[0].latitude;
                for (let i = 1; i < pts.length; i++) {
                    if (pts[i].longitude < left)
                        left = pts[i].longitude;
                    if (pts[i].longitude > right)
                        right = pts[i].longitude;
                    if (pts[i].latitude < bottom)
                        bottom = pts[i].latitude;
                    if (pts[i].latitude > top)
                        top = pts[i].latitude;
                }
                let bl = [left, bottom];
                let tl = [left, top];
                let tr = [right, top];
                let br = [right, bottom];
                rings.push(bl);
                rings.push(tl);
                rings.push(tr);
                rings.push(br);
                rings.push(bl);
                let poly = this._mapService.getPolygonInstance({
                    type: "polygon",
                    rings: rings,
                    spatialReference: { wkid: 4326 },
                });
                this.mapView.goTo({ target: poly }).then(() => {
                    this.mapView.zoom = this.mapView.zoom - 1;
                });
            }
            else {
                this.mapView.goTo({
                    center: [pts[0].longitude, pts[0].latitude],
                    zoom: 18,
                });
            }
        });
    }
};
MapComponent.ɵfac = function MapComponent_Factory(t) { return new (t || MapComponent)(ɵngcc0.ɵɵdirectiveInject(MapService), ɵngcc0.ɵɵdirectiveInject(DynamicEsriLoaderService), ɵngcc0.ɵɵdirectiveInject(AuthService), ɵngcc0.ɵɵdirectiveInject(ActionMapEventControllerService)); };
MapComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MapComponent, selectors: [["app-map"]], viewQuery: function MapComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.el = _t.first);
    } }, outputs: { mapMessage: "mapMessage", popupAction: "popupAction", mapActionExtents: "mapActionExtents" }, decls: 2, vars: 0, consts: [[1, "map"], ["map", ""]], template: function MapComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".map[_ngcontent-%COMP%]{width:100%;height:100%;margin:0;padding:0}"] });
__decorate([
    ViewChild("map", { static: true }),
    __metadata("design:type", ElementRef)
], MapComponent.prototype, "el", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MapComponent.prototype, "mapMessage", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MapComponent.prototype, "popupAction", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MapComponent.prototype, "mapActionExtents", void 0);
MapComponent = __decorate([ __metadata("design:paramtypes", [MapService,
        DynamicEsriLoaderService,
        AuthService,
        ActionMapEventControllerService])
], MapComponent);

let MapModule = class MapModule {
};
MapModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MapModule });
MapModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MapModule_Factory(t) { return new (t || MapModule)(); }, providers: [
        MapService,
        AuthService,
        ClusterLayerService,
        DynamicEsriLoaderService,
        ExpandableWidgetControllerService,
        GeometryService,
        LayerManagerService,
        ActionMapEventControllerService,
        PopupActionControllerService,
        SketchViewModelMakerService
    ], imports: [[
            CommonModule
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ClusterLayerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ExpandableWidgetControllerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GeometryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PopupActionControllerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ActionMapEventControllerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GeometryService }, { type: PopupActionControllerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayerManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SketchViewModelMakerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ElevationProfileService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: SketchViewModelMakerService }, { type: GeometryService }, { type: ActionMapEventControllerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoadWidgetsHelperService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MapService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ClusterLayerService }, { type: GeometryService }, { type: ExpandableWidgetControllerService }, { type: LayerManagerService }, { type: SketchViewModelMakerService }, { type: ActionMapEventControllerService }, { type: PopupActionControllerService }, { type: ElevationProfileService }, { type: LoadWidgetsHelperService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicEsriLoaderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MapComponent, [{
        type: Component,
        args: [{
                selector: "app-map",
                template: "<div class=\"map\" #map></div>",
                styles: [".map{width:100%;height:100%;margin:0;padding:0}"]
            }]
    }], function () { return [{ type: MapService }, { type: DynamicEsriLoaderService }, { type: AuthService }, { type: ActionMapEventControllerService }]; }, { mapMessage: [{
            type: Output
        }], popupAction: [{
            type: Output
        }], mapActionExtents: [{
            type: Output
        }], el: [{
            type: ViewChild,
            args: ["map", { static: true }]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MapModule, { declarations: function () { return [MapComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [MapComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MapModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                exports: [MapComponent],
                declarations: [MapComponent],
                providers: [
                    MapService,
                    AuthService,
                    ClusterLayerService,
                    DynamicEsriLoaderService,
                    ExpandableWidgetControllerService,
                    GeometryService,
                    LayerManagerService,
                    ActionMapEventControllerService,
                    PopupActionControllerService,
                    SketchViewModelMakerService
                ]
            }]
    }], null, null); })();

export { DOJO_CONFIG, EActiveClickType, EButtonPosition, ELayerType, EMapType, EThirdPartyMapButton, IPopupActionProperties, JS_API_VERSION, MapComponent, MapConfig2, MapConfig2Maker, MapInstance, MapInstanceMaker, MapModule, MapService, QueryProperties, ClusterLayerService as ɵa, GeometryService as ɵb, ExpandableWidgetControllerService as ɵc, LayerManagerService as ɵd, SketchViewModelMakerService as ɵe, ActionMapEventControllerService as ɵf, PopupActionControllerService as ɵg, ElevationProfileService as ɵh, LoadWidgetsHelperService as ɵi, DynamicEsriLoaderService as ɵj, AuthService as ɵk };

//# sourceMappingURL=dustwhirl-ng-esri-jsapi-map.js.map